function PlanX({ ...props }) {
	return (
		<g {...props} id="unit-x">
			<g id="furniture">
				<polyline
					points="863.29 559.85 863.29 561.77 859.49 561.77 859.49 559.85 863.29 559.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="609.72"
					y1="333.68"
					x2="609.72"
					y2="453.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.52"
					y1="403.04"
					x2="638.52"
					y2="398.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.52"
					y1="395.66"
					x2="638.52"
					y2="391.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.52"
					y1="388.29"
					x2="638.52"
					y2="383.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.52"
					y1="380.92"
					x2="638.52"
					y2="376.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.52"
					y1="373.54"
					x2="638.52"
					y2="368.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.52"
					y1="366.17"
					x2="638.52"
					y2="361.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.32"
					y1="333.68"
					x2="611.64"
					y2="333.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="333.68"
					x2="611.64"
					y2="336.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="339.45"
					x2="611.64"
					y2="344.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="346.82"
					x2="611.64"
					y2="351.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="354.19"
					x2="611.64"
					y2="358.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="361.56"
					x2="611.64"
					y2="366.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="368.94"
					x2="611.64"
					y2="373.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="376.31"
					x2="611.64"
					y2="380.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="383.68"
					x2="611.64"
					y2="388.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="391.05"
					x2="611.64"
					y2="395.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="398.43"
					x2="611.64"
					y2="403.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="405.8"
					x2="611.64"
					y2="410.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="413.17"
					x2="611.64"
					y2="417.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="420.55"
					x2="611.64"
					y2="425.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="427.92"
					x2="611.64"
					y2="432.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="435.29"
					x2="611.64"
					y2="439.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="442.67"
					x2="611.64"
					y2="447.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="450.04"
					x2="611.64"
					y2="453.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="453.04"
					x2="616.32"
					y2="453.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.09"
					y1="453.04"
					x2="623.69"
					y2="453.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.72"
					y1="462.64"
					x2="609.72"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.69"
					y1="462.64"
					x2="619.09"
					y2="462.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.32"
					y1="462.64"
					x2="611.64"
					y2="462.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="462.64"
					x2="611.64"
					y2="465.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="468.63"
					x2="611.64"
					y2="473.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="476"
					x2="611.64"
					y2="480.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="483.37"
					x2="611.64"
					y2="487.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="490.75"
					x2="611.64"
					y2="495.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="498.12"
					x2="611.64"
					y2="502.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="505.49"
					x2="611.64"
					y2="510.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="512.86"
					x2="611.64"
					y2="517.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="520.24"
					x2="611.64"
					y2="524.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="527.61"
					x2="611.64"
					y2="532.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="534.99"
					x2="611.64"
					y2="539.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="542.36"
					x2="611.64"
					y2="546.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="549.73"
					x2="611.64"
					y2="554.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="557.1"
					x2="611.64"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.64"
					y1="560.33"
					x2="616.32"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.09"
					y1="560.33"
					x2="623.69"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="77.28"
					y1="560.33"
					x2="81.89"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.66"
					y1="560.33"
					x2="89.27"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.03"
					y1="560.33"
					x2="96.64"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="99.4"
					y1="560.33"
					x2="104.01"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="106.78"
					y1="560.33"
					x2="111.38"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="114.15"
					y1="560.33"
					x2="118.76"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="121.52"
					y1="560.33"
					x2="126.13"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.89"
					y1="560.33"
					x2="133.5"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.27"
					y1="560.33"
					x2="140.88"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="143.64"
					y1="560.33"
					x2="148.25"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="151.01"
					y1="560.33"
					x2="155.62"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="158.39"
					y1="560.33"
					x2="162.99"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.76"
					y1="560.33"
					x2="170.37"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="173.13"
					y1="560.33"
					x2="177.74"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="180.5"
					y1="560.33"
					x2="185.11"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.88"
					y1="560.33"
					x2="192.49"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.49"
					y1="533.45"
					x2="187.88"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.11"
					y1="533.45"
					x2="180.5"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.74"
					y1="533.45"
					x2="173.13"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="170.37"
					y1="533.45"
					x2="165.76"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="162.99"
					y1="533.45"
					x2="158.39"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="155.62"
					y1="533.45"
					x2="151.01"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.25"
					y1="533.45"
					x2="143.64"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="140.88"
					y1="533.45"
					x2="136.27"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="133.5"
					y1="533.45"
					x2="128.89"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="126.13"
					y1="533.45"
					x2="121.52"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="118.76"
					y1="533.45"
					x2="114.15"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.38"
					y1="533.45"
					x2="106.78"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.01"
					y1="533.45"
					x2="99.4"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.64"
					y1="533.45"
					x2="92.03"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.27"
					y1="533.45"
					x2="84.66"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="81.89"
					y1="533.45"
					x2="77.28"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.52"
					y1="533.45"
					x2="69.91"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="67.15"
					y1="533.45"
					x2="65.36"
					y2="533.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="65.36"
					y1="533.45"
					x2="65.36"
					y2="538.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="65.36"
					y1="540.9"
					x2="65.36"
					y2="545.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="281.23 673.77 333.07 673.77 333.07 725.6 281.23 725.6 281.23 673.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="844.7 257.9 812.53 257.9 812.53 262.06 844.7 262.06 844.7 257.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="811.02 257.52 846.21 257.52 846.21 257.9 811.02 257.9 811.02 257.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="811.02"
					y1="257.52"
					x2="846.21"
					y2="257.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.21"
					y1="257.52"
					x2="846.21"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.21"
					y1="257.9"
					x2="811.02"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.02"
					y1="257.9"
					x2="811.02"
					y2="257.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.7"
					y1="262.06"
					x2="812.53"
					y2="262.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.53"
					y1="257.9"
					x2="844.7"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="848.1 262.06 844.7 262.06 844.7 257.9 848.1 257.9 848.1 262.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="848.1"
					y1="262.06"
					x2="844.7"
					y2="262.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.7"
					y1="262.06"
					x2="844.7"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.7"
					y1="257.9"
					x2="848.1"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.1"
					y1="257.9"
					x2="848.1"
					y2="262.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="809.13 257.9 812.53 257.9 812.53 262.06 809.13 262.06 809.13 257.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="809.13"
					y1="257.9"
					x2="812.53"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.53"
					y1="257.9"
					x2="812.53"
					y2="262.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.53"
					y1="262.06"
					x2="809.13"
					y2="262.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="809.13"
					y1="262.06"
					x2="809.13"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.7"
					y1="258.66"
					x2="812.53"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="849.61 261.68 848.1 261.68 848.1 257.9 846.21 257.9 846.21 257.52 849.61 257.52 849.61 261.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="849.61"
					y1="261.68"
					x2="848.1"
					y2="261.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.1"
					y1="261.68"
					x2="848.1"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.1"
					y1="257.9"
					x2="846.21"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.21"
					y1="257.9"
					x2="846.21"
					y2="257.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.21"
					y1="257.52"
					x2="849.61"
					y2="257.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.61"
					y1="257.52"
					x2="849.61"
					y2="261.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="807.62 257.52 811.02 257.52 811.02 257.9 809.13 257.9 809.13 261.68 807.62 261.68 807.62 257.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="807.62"
					y1="257.52"
					x2="811.02"
					y2="257.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.02"
					y1="257.52"
					x2="811.02"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.02"
					y1="257.9"
					x2="809.13"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="809.13"
					y1="257.9"
					x2="809.13"
					y2="261.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="809.13"
					y1="261.68"
					x2="807.62"
					y2="261.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.62"
					y1="261.68"
					x2="807.62"
					y2="257.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="805.69 258.66 805.69 260.58 705.74 260.58 705.74 258.66 805.69 258.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="805.69"
					y1="258.66"
					x2="805.69"
					y2="260.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="805.69"
					y1="260.58"
					x2="705.74"
					y2="260.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.74"
					y1="260.58"
					x2="705.74"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.74"
					y1="258.66"
					x2="805.69"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="849.61 258.66 853.45 258.66 853.45 270.18 849.61 270.18 849.61 258.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="853.45"
					y1="258.66"
					x2="849.61"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.45"
					y1="270.18"
					x2="853.45"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.61"
					y1="270.18"
					x2="853.45"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.61"
					y1="258.66"
					x2="849.61"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="803.77 258.66 807.62 258.66 807.62 270.18 803.77 270.18 803.77 258.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="807.62"
					y1="258.66"
					x2="803.77"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.62"
					y1="270.18"
					x2="807.62"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.77"
					y1="270.18"
					x2="807.62"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.77"
					y1="258.66"
					x2="803.77"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="703.82 258.66 707.66 258.66 707.66 270.18 703.82 270.18 703.82 258.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="707.66"
					y1="258.66"
					x2="703.82"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.66"
					y1="270.18"
					x2="707.66"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.82"
					y1="270.18"
					x2="707.66"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.82"
					y1="258.66"
					x2="703.82"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="532.81 257.9 501.11 257.9 501.11 262.06 532.81 262.06 532.81 257.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="499.6 257.52 534.32 257.52 534.32 257.9 499.6 257.9 499.6 257.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="499.6"
					y1="257.52"
					x2="534.32"
					y2="257.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.32"
					y1="257.52"
					x2="534.32"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.32"
					y1="257.9"
					x2="499.6"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.6"
					y1="257.9"
					x2="499.6"
					y2="257.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.81"
					y1="262.06"
					x2="501.11"
					y2="262.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.11"
					y1="257.9"
					x2="532.81"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="536.21 262.06 532.81 262.06 532.81 257.9 536.21 257.9 536.21 262.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="536.21"
					y1="262.06"
					x2="532.81"
					y2="262.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.81"
					y1="262.06"
					x2="532.81"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.81"
					y1="257.9"
					x2="536.21"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.21"
					y1="257.9"
					x2="536.21"
					y2="262.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="497.71 257.9 501.11 257.9 501.11 262.06 497.71 262.06 497.71 257.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="497.71"
					y1="257.9"
					x2="501.11"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.11"
					y1="257.9"
					x2="501.11"
					y2="262.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.11"
					y1="262.06"
					x2="497.71"
					y2="262.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.71"
					y1="262.06"
					x2="497.71"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.81"
					y1="258.66"
					x2="501.11"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="537.73 261.68 536.21 261.68 536.21 257.9 534.32 257.9 534.32 257.52 537.73 257.52 537.73 261.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="537.73"
					y1="261.68"
					x2="536.21"
					y2="261.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.21"
					y1="261.68"
					x2="536.21"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.21"
					y1="257.9"
					x2="534.32"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.32"
					y1="257.9"
					x2="534.32"
					y2="257.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.32"
					y1="257.52"
					x2="537.73"
					y2="257.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.73"
					y1="257.52"
					x2="537.73"
					y2="261.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="496.2 257.52 499.6 257.52 499.6 257.9 497.71 257.9 497.71 261.68 496.2 261.68 496.2 257.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="496.2"
					y1="257.52"
					x2="499.6"
					y2="257.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.6"
					y1="257.52"
					x2="499.6"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.6"
					y1="257.9"
					x2="497.71"
					y2="257.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.71"
					y1="257.9"
					x2="497.71"
					y2="261.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.71"
					y1="261.68"
					x2="496.2"
					y2="261.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.2"
					y1="261.68"
					x2="496.2"
					y2="257.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="494.28 258.66 494.28 260.58 414.7 260.58 414.7 258.66 494.28 258.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="494.28"
					y1="258.66"
					x2="494.28"
					y2="260.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.28"
					y1="260.58"
					x2="414.7"
					y2="260.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.7"
					y1="260.58"
					x2="414.7"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.7"
					y1="258.66"
					x2="494.28"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="537.73 258.66 541.56 258.66 541.56 270.18 537.73 270.18 537.73 258.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="541.56"
					y1="258.66"
					x2="537.73"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.56"
					y1="270.18"
					x2="541.56"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.73"
					y1="270.18"
					x2="541.56"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.73"
					y1="258.66"
					x2="537.73"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="492.36 258.66 496.2 258.66 496.2 270.18 492.36 270.18 492.36 258.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="496.2"
					y1="258.66"
					x2="492.36"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.2"
					y1="270.18"
					x2="496.2"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.36"
					y1="270.18"
					x2="496.2"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.36"
					y1="258.66"
					x2="492.36"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="412.78 258.66 416.62 258.66 416.62 270.18 412.78 270.18 412.78 258.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="416.62"
					y1="258.66"
					x2="412.78"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.62"
					y1="270.18"
					x2="416.62"
					y2="258.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.78"
					y1="270.18"
					x2="416.62"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.78"
					y1="258.66"
					x2="412.78"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.34"
					y1="270.18"
					x2="130.5"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="134.34"
					y1="263.46"
					x2="134.34"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="134.34"
					y1="254.82"
					x2="130.5"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="134.34"
					y1="254.82"
					x2="134.34"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="192.9"
					y1="270.18"
					x2="196.74"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="192.9"
					y1="263.46"
					x2="192.9"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="192.9"
					y1="254.82"
					x2="196.74"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="192.9"
					y1="254.82"
					x2="192.9"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="412.78"
					y1="254.82"
					x2="412.78"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<polyline
					points="192.9 254.82 196.74 254.82 196.74 251.94 130.5 251.94 130.5 254.82 134.34 254.82 192.9 254.82"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="134.34 263.46 134.34 270.18 130.5 270.18 130.5 273.06 196.74 273.06 196.74 270.18 192.9 270.18 192.9 263.46 134.34 263.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="196.74"
					y1="254.82"
					x2="196.74"
					y2="251.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.74"
					y1="251.94"
					x2="130.5"
					y2="251.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.5"
					y1="251.94"
					x2="130.5"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.74"
					y1="270.18"
					x2="196.74"
					y2="273.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.74"
					y1="273.06"
					x2="130.5"
					y2="273.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.5"
					y1="273.06"
					x2="130.5"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="189.54 254.82 163.62 254.82 163.62 263.46 189.54 263.46 189.54 260.1 189.54 254.82"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="192.42 263.46 192.42 254.82 189.54 254.82 189.54 260.1 189.54 263.46 192.42 263.46"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="163.62 254.82 137.7 254.82 137.7 260.1 137.7 263.46 163.62 263.46 163.62 254.82"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="134.82 254.82 134.82 263.46 137.7 263.46 137.7 260.1 137.7 254.82 134.82 254.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="192.42"
					y1="263.46"
					x2="189.54"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.54"
					y1="263.46"
					x2="189.54"
					y2="260.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.54"
					y1="260.1"
					x2="189.54"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.54"
					y1="254.82"
					x2="192.42"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.42"
					y1="254.82"
					x2="192.42"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.9"
					y1="263.46"
					x2="192.42"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.42"
					y1="263.46"
					x2="192.42"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.42"
					y1="254.82"
					x2="192.9"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.9"
					y1="254.82"
					x2="192.9"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.82"
					y1="254.82"
					x2="137.7"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.7"
					y1="254.82"
					x2="137.7"
					y2="260.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.7"
					y1="260.1"
					x2="137.7"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.7"
					y1="263.46"
					x2="134.82"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.82"
					y1="263.46"
					x2="134.82"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.34"
					y1="254.82"
					x2="134.82"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.82"
					y1="254.82"
					x2="134.82"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.82"
					y1="263.46"
					x2="134.34"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.34"
					y1="263.46"
					x2="134.34"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="185.22 260.1 142.02 260.1 142.02 263.46 185.22 263.46 185.22 260.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="189.54 260.1 185.22 260.1 185.22 263.46 189.54 263.46 189.54 260.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="137.7 263.46 142.02 263.46 142.02 260.1 137.7 260.1 137.7 263.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="192.9"
					y1="254.82"
					x2="192.9"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="192.9"
					y1="254.82"
					x2="192.9"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="192.9"
					y1="254.82"
					x2="196.74"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="192.9"
					y1="263.46"
					x2="192.9"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="192.9"
					y1="270.18"
					x2="196.74"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="134.34"
					y1="254.82"
					x2="134.34"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="134.34"
					y1="254.82"
					x2="134.34"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="134.34"
					y1="254.82"
					x2="130.5"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="134.34"
					y1="263.46"
					x2="134.34"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="134.34"
					y1="270.18"
					x2="130.5"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="185.22"
					y1="261.78"
					x2="142.02"
					y2="261.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.54"
					y1="260.1"
					x2="185.22"
					y2="260.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.22"
					y1="260.1"
					x2="185.22"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.22"
					y1="263.46"
					x2="189.54"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.54"
					y1="263.46"
					x2="189.54"
					y2="260.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.7"
					y1="263.46"
					x2="142.02"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="142.02"
					y1="263.46"
					x2="142.02"
					y2="260.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="142.02"
					y1="260.1"
					x2="137.7"
					y2="260.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.7"
					y1="260.1"
					x2="137.7"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.22"
					y1="260.1"
					x2="142.02"
					y2="260.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="142.02"
					y1="263.46"
					x2="185.22"
					y2="263.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.28"
					y1="747.1"
					x2="348.4"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="351.28"
					y1="731.74"
					x2="348.4"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="351.28"
					y1="731.74"
					x2="351.28"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="424.24"
					y1="747.1"
					x2="427.12"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="424.24"
					y1="731.74"
					x2="427.12"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="424.24"
					y1="731.74"
					x2="424.24"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="351.28"
					y1="731.74"
					x2="346.73"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<polyline
					points="423.28 748.06 427.12 748.06 427.12 747.1 423.28 747.1 423.28 748.06"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="352.24 747.1 348.4 747.1 348.4 748.06 352.24 748.06 352.24 747.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="423.28 731.74 427.12 731.74 427.12 730.78 423.28 730.78 423.28 731.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="352.24 730.78 348.4 730.78 348.4 731.74 352.24 731.74 352.24 730.78"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="423.28"
					y1="748.06"
					x2="427.12"
					y2="748.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.12"
					y1="748.06"
					x2="427.12"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.12"
					y1="747.1"
					x2="423.28"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.28"
					y1="747.1"
					x2="423.28"
					y2="748.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.24"
					y1="747.1"
					x2="348.4"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.4"
					y1="747.1"
					x2="348.4"
					y2="748.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.4"
					y1="748.06"
					x2="352.24"
					y2="748.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.24"
					y1="748.06"
					x2="352.24"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.28"
					y1="731.74"
					x2="427.12"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.12"
					y1="731.74"
					x2="427.12"
					y2="730.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.12"
					y1="730.78"
					x2="423.28"
					y2="730.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.28"
					y1="730.78"
					x2="423.28"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.24"
					y1="730.78"
					x2="348.4"
					y2="730.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.4"
					y1="730.78"
					x2="348.4"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.4"
					y1="731.74"
					x2="352.24"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.24"
					y1="731.74"
					x2="352.24"
					y2="730.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="422.32 747.1 423.76 747.1 423.76 731.74 422.32 731.74 422.32 747.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="351.76 747.1 353.2 747.1 353.2 731.74 351.76 731.74 351.76 747.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="402.08 682.87 353.2 731.74 355.58 734.12 404.45 685.24 402.08 682.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="423.76"
					y1="731.74"
					x2="424.24"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.76"
					y1="747.1"
					x2="424.24"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.24"
					y1="731.74"
					x2="424.24"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.76"
					y1="731.74"
					x2="351.28"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.76"
					y1="747.1"
					x2="351.28"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.28"
					y1="731.74"
					x2="351.28"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.32"
					y1="747.1"
					x2="422.32"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.32"
					y1="731.74"
					x2="423.76"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.76"
					y1="731.74"
					x2="423.76"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.76"
					y1="747.1"
					x2="422.32"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.76"
					y1="747.1"
					x2="351.76"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.76"
					y1="731.74"
					x2="353.2"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.2"
					y1="731.74"
					x2="353.2"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.2"
					y1="747.1"
					x2="351.76"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.08"
					y1="682.87"
					x2="404.45"
					y2="685.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.45"
					y1="685.24"
					x2="355.58"
					y2="734.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.58"
					y1="734.12"
					x2="353.2"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.2"
					y1="731.74"
					x2="402.08"
					y2="682.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.24"
					y1="731.74"
					x2="424.24"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="424.24"
					y1="731.74"
					x2="424.24"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="424.24"
					y1="731.74"
					x2="427.12"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="424.24"
					y1="731.74"
					x2="427.12"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="424.24"
					y1="747.1"
					x2="427.12"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="424.24"
					y1="747.1"
					x2="427.12"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="351.28"
					y1="731.74"
					x2="351.28"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="351.28"
					y1="731.74"
					x2="351.28"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="351.28"
					y1="731.74"
					x2="348.4"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="351.28"
					y1="731.74"
					x2="348.4"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="351.28"
					y1="747.1"
					x2="348.4"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="351.28"
					y1="747.1"
					x2="348.4"
					y2="747.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="251.22"
					y1="580.63"
					x2="251.22"
					y2="577.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="241.62"
					y1="580.63"
					x2="241.62"
					y2="577.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="241.62"
					y1="580.63"
					x2="251.22"
					y2="580.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="251.22"
					y1="642.07"
					x2="251.22"
					y2="644.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="241.62"
					y1="642.07"
					x2="241.62"
					y2="644.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="241.62"
					y1="642.07"
					x2="251.22"
					y2="642.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="251.22"
					y1="659.03"
					x2="251.22"
					y2="642.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="241.62"
					y1="642.07"
					x2="241.62"
					y2="699.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<polyline
					points="252.18 641.11 251.22 641.11 251.22 644.95 252.18 644.95 252.18 641.11"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="251.22 581.59 252.18 581.59 252.18 577.75 251.22 577.75 251.22 581.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="241.62 641.11 240.66 641.11 240.66 644.95 241.62 644.95 241.62 641.11"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="240.66 581.59 241.62 581.59 241.62 577.75 240.66 577.75 240.66 581.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="252.18"
					y1="641.11"
					x2="252.18"
					y2="644.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.18"
					y1="644.95"
					x2="251.22"
					y2="644.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.22"
					y1="644.95"
					x2="251.22"
					y2="641.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.22"
					y1="641.11"
					x2="252.18"
					y2="641.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.22"
					y1="581.59"
					x2="251.22"
					y2="577.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.22"
					y1="577.75"
					x2="252.18"
					y2="577.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.18"
					y1="577.75"
					x2="252.18"
					y2="581.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.18"
					y1="581.59"
					x2="251.22"
					y2="581.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.62"
					y1="641.11"
					x2="241.62"
					y2="644.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.62"
					y1="644.95"
					x2="240.66"
					y2="644.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.66"
					y1="644.95"
					x2="240.66"
					y2="641.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.66"
					y1="641.11"
					x2="241.62"
					y2="641.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.66"
					y1="581.59"
					x2="240.66"
					y2="577.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.66"
					y1="577.75"
					x2="241.62"
					y2="577.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.62"
					y1="577.75"
					x2="241.62"
					y2="581.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.62"
					y1="581.59"
					x2="240.66"
					y2="581.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="251.22 640.15 241.62 640.15 241.62 641.59 251.22 641.59 251.22 640.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="251.22 581.11 241.62 581.11 241.62 582.55 251.22 582.55 251.22 581.11"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="200.89 623.28 203.26 625.66 243.99 584.93 241.62 582.55 200.89 623.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="241.62"
					y1="641.59"
					x2="241.62"
					y2="642.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.22"
					y1="641.59"
					x2="251.22"
					y2="642.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.62"
					y1="642.07"
					x2="251.22"
					y2="642.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.62"
					y1="581.11"
					x2="241.62"
					y2="580.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.22"
					y1="581.11"
					x2="251.22"
					y2="580.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.62"
					y1="580.63"
					x2="251.22"
					y2="580.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.22"
					y1="640.15"
					x2="241.62"
					y2="640.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.62"
					y1="640.15"
					x2="241.62"
					y2="641.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.62"
					y1="641.59"
					x2="251.22"
					y2="641.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.22"
					y1="641.59"
					x2="251.22"
					y2="640.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.22"
					y1="581.11"
					x2="241.62"
					y2="581.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.62"
					y1="581.11"
					x2="241.62"
					y2="582.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.62"
					y1="582.55"
					x2="251.22"
					y2="582.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.22"
					y1="582.55"
					x2="251.22"
					y2="581.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.89"
					y1="623.28"
					x2="203.26"
					y2="625.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.26"
					y1="625.66"
					x2="243.99"
					y2="584.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.99"
					y1="584.93"
					x2="241.62"
					y2="582.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.62"
					y1="582.55"
					x2="200.89"
					y2="623.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.62"
					y1="642.07"
					x2="251.22"
					y2="642.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="241.62"
					y1="642.07"
					x2="251.22"
					y2="642.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="241.62"
					y1="642.07"
					x2="241.62"
					y2="644.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="241.62"
					y1="642.07"
					x2="241.62"
					y2="644.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="251.22"
					y1="642.07"
					x2="251.22"
					y2="644.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="251.22"
					y1="642.07"
					x2="251.22"
					y2="644.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="241.62"
					y1="580.63"
					x2="251.22"
					y2="580.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="241.62"
					y1="580.63"
					x2="251.22"
					y2="580.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="241.62"
					y1="580.63"
					x2="241.62"
					y2="577.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="241.62"
					y1="580.63"
					x2="241.62"
					y2="577.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="251.22"
					y1="580.63"
					x2="251.22"
					y2="577.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="251.22"
					y1="580.63"
					x2="251.22"
					y2="577.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="350.9"
					y1="569.93"
					x2="353.78"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="350.9"
					y1="560.33"
					x2="353.78"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="350.9"
					y1="560.33"
					x2="350.9"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="289.46"
					y1="569.93"
					x2="286.58"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="289.46"
					y1="560.33"
					x2="286.58"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="289.46"
					y1="560.33"
					x2="289.46"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="573.69"
					y1="569.93"
					x2="576.57"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="573.69"
					y1="560.33"
					x2="576.57"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="573.69"
					y1="560.33"
					x2="573.69"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="512.25"
					y1="569.93"
					x2="509.37"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="512.25"
					y1="560.33"
					x2="509.37"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="512.25"
					y1="560.33"
					x2="512.25"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="560.33"
					x2="573.69"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<polyline
					points="290.42 570.89 290.42 569.93 286.58 569.93 286.58 570.89 290.42 570.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="349.94 569.93 349.94 570.89 353.78 570.89 353.78 569.93 349.94 569.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="290.42 560.33 290.42 559.37 286.58 559.37 286.58 560.33 290.42 560.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="349.94 559.37 349.94 560.33 353.78 560.33 353.78 559.37 349.94 559.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="290.42"
					y1="570.89"
					x2="286.58"
					y2="570.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.58"
					y1="570.89"
					x2="286.58"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.58"
					y1="569.93"
					x2="290.42"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.42"
					y1="569.93"
					x2="290.42"
					y2="570.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.94"
					y1="569.93"
					x2="353.78"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.78"
					y1="569.93"
					x2="353.78"
					y2="570.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.78"
					y1="570.89"
					x2="349.94"
					y2="570.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.94"
					y1="570.89"
					x2="349.94"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.42"
					y1="560.33"
					x2="286.58"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.58"
					y1="560.33"
					x2="286.58"
					y2="559.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.58"
					y1="559.37"
					x2="290.42"
					y2="559.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.42"
					y1="559.37"
					x2="290.42"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.94"
					y1="559.37"
					x2="353.78"
					y2="559.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.78"
					y1="559.37"
					x2="353.78"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.78"
					y1="560.33"
					x2="349.94"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.94"
					y1="560.33"
					x2="349.94"
					y2="559.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="291.38 569.93 291.38 560.33 289.94 560.33 289.94 569.93 291.38 569.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="350.42 569.93 350.42 560.33 348.98 560.33 348.98 569.93 350.42 569.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="308.25 519.6 305.88 521.98 346.61 562.71 348.98 560.33 308.25 519.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="289.94"
					y1="560.33"
					x2="289.46"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.94"
					y1="569.93"
					x2="289.46"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.46"
					y1="560.33"
					x2="289.46"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.42"
					y1="560.33"
					x2="350.9"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.42"
					y1="569.93"
					x2="350.9"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.9"
					y1="560.33"
					x2="350.9"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.38"
					y1="569.93"
					x2="291.38"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.38"
					y1="560.33"
					x2="289.94"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.94"
					y1="560.33"
					x2="289.94"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.94"
					y1="569.93"
					x2="291.38"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.42"
					y1="569.93"
					x2="350.42"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.42"
					y1="560.33"
					x2="348.98"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.98"
					y1="560.33"
					x2="348.98"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.98"
					y1="569.93"
					x2="350.42"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.25"
					y1="519.6"
					x2="305.88"
					y2="521.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.88"
					y1="521.98"
					x2="346.61"
					y2="562.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.61"
					y1="562.71"
					x2="348.98"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.98"
					y1="560.33"
					x2="308.25"
					y2="519.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.46"
					y1="560.33"
					x2="289.46"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="289.46"
					y1="560.33"
					x2="289.46"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="289.46"
					y1="560.33"
					x2="286.58"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="289.46"
					y1="560.33"
					x2="286.58"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="289.46"
					y1="569.93"
					x2="286.58"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="289.46"
					y1="569.93"
					x2="286.58"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="350.9"
					y1="560.33"
					x2="350.9"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="350.9"
					y1="560.33"
					x2="350.9"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="350.9"
					y1="560.33"
					x2="353.78"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="350.9"
					y1="560.33"
					x2="353.78"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="350.9"
					y1="569.93"
					x2="353.78"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="350.9"
					y1="569.93"
					x2="353.78"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<polyline
					points="513.21 570.89 513.21 569.93 509.37 569.93 509.37 570.89 513.21 570.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="572.73 569.93 572.73 570.89 576.57 570.89 576.57 569.93 572.73 569.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="513.21 560.33 513.21 559.37 509.37 559.37 509.37 560.33 513.21 560.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="572.73 559.37 572.73 560.33 576.57 560.33 576.57 559.37 572.73 559.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="513.21"
					y1="570.89"
					x2="509.37"
					y2="570.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.37"
					y1="570.89"
					x2="509.37"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.37"
					y1="569.93"
					x2="513.21"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.21"
					y1="569.93"
					x2="513.21"
					y2="570.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.73"
					y1="569.93"
					x2="576.57"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.57"
					y1="569.93"
					x2="576.57"
					y2="570.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.57"
					y1="570.89"
					x2="572.73"
					y2="570.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.73"
					y1="570.89"
					x2="572.73"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.21"
					y1="560.33"
					x2="509.37"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.37"
					y1="560.33"
					x2="509.37"
					y2="559.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.37"
					y1="559.37"
					x2="513.21"
					y2="559.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.21"
					y1="559.37"
					x2="513.21"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.73"
					y1="559.37"
					x2="576.57"
					y2="559.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.57"
					y1="559.37"
					x2="576.57"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.57"
					y1="560.33"
					x2="572.73"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.73"
					y1="560.33"
					x2="572.73"
					y2="559.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="514.17 569.93 514.17 560.33 512.73 560.33 512.73 569.93 514.17 569.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="573.21 569.93 573.21 560.33 571.77 560.33 571.77 569.93 573.21 569.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="531.04 519.6 528.66 521.98 569.39 562.71 571.77 560.33 531.04 519.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="512.73"
					y1="560.33"
					x2="512.25"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.73"
					y1="569.93"
					x2="512.25"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.25"
					y1="560.33"
					x2="512.25"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.21"
					y1="560.33"
					x2="573.69"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.21"
					y1="569.93"
					x2="573.69"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.69"
					y1="560.33"
					x2="573.69"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.17"
					y1="569.93"
					x2="514.17"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.17"
					y1="560.33"
					x2="512.73"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.73"
					y1="560.33"
					x2="512.73"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.73"
					y1="569.93"
					x2="514.17"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.21"
					y1="569.93"
					x2="573.21"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.21"
					y1="560.33"
					x2="571.77"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.77"
					y1="560.33"
					x2="571.77"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.77"
					y1="569.93"
					x2="573.21"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.04"
					y1="519.6"
					x2="528.66"
					y2="521.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.66"
					y1="521.98"
					x2="569.39"
					y2="562.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.39"
					y1="562.71"
					x2="571.77"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.77"
					y1="560.33"
					x2="531.04"
					y2="519.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.25"
					y1="560.33"
					x2="512.25"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="512.25"
					y1="560.33"
					x2="512.25"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="512.25"
					y1="560.33"
					x2="509.37"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="512.25"
					y1="560.33"
					x2="509.37"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="512.25"
					y1="569.93"
					x2="509.37"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="512.25"
					y1="569.93"
					x2="509.37"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="573.69"
					y1="560.33"
					x2="573.69"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="573.69"
					y1="560.33"
					x2="573.69"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="573.69"
					y1="560.33"
					x2="576.57"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="573.69"
					y1="560.33"
					x2="576.57"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="573.69"
					y1="569.93"
					x2="576.57"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="573.69"
					y1="569.93"
					x2="576.57"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="648.12"
					y1="569.93"
					x2="648.12"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="87.26"
					y1="516.05"
					x2="84.86"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="87.26"
					y1="514.13"
					x2="87.26"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="87.26"
					y1="506.45"
					x2="84.86"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="87.26"
					y1="506.45"
					x2="87.26"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="188.06"
					y1="516.05"
					x2="190.46"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="188.06"
					y1="514.13"
					x2="188.06"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="188.06"
					y1="506.45"
					x2="190.46"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="188.06"
					y1="506.45"
					x2="188.06"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<polyline
					points="186.62 514.13 186.62 516.05 187.58 516.05 187.58 514.13 186.62 514.13"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="186.62 517.01 190.46 517.01 190.46 516.05 186.62 516.05 186.62 517.01"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="87.74 514.13 87.74 516.05 88.7 516.05 88.7 514.13 87.74 514.13"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="88.7 516.05 84.86 516.05 84.86 517.01 88.7 517.01 88.7 516.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="186.62 506.45 190.46 506.45 190.46 504.05 186.62 504.05 186.62 506.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="88.7 504.05 84.86 504.05 84.86 506.45 88.7 506.45 88.7 504.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="186.62"
					y1="514.13"
					x2="186.62"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.62"
					y1="516.05"
					x2="187.58"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.58"
					y1="516.05"
					x2="187.58"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.58"
					y1="514.13"
					x2="186.62"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.62"
					y1="517.01"
					x2="190.46"
					y2="517.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.46"
					y1="517.01"
					x2="190.46"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.46"
					y1="516.05"
					x2="186.62"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.62"
					y1="516.05"
					x2="186.62"
					y2="517.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.74"
					y1="514.13"
					x2="87.74"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.74"
					y1="516.05"
					x2="88.7"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.7"
					y1="516.05"
					x2="88.7"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.7"
					y1="514.13"
					x2="87.74"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.7"
					y1="516.05"
					x2="84.86"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.86"
					y1="516.05"
					x2="84.86"
					y2="517.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.86"
					y1="517.01"
					x2="88.7"
					y2="517.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.7"
					y1="517.01"
					x2="88.7"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.62"
					y1="506.45"
					x2="190.46"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.46"
					y1="506.45"
					x2="190.46"
					y2="504.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.46"
					y1="504.05"
					x2="186.62"
					y2="504.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.62"
					y1="504.05"
					x2="186.62"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.7"
					y1="504.05"
					x2="84.86"
					y2="504.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.86"
					y1="504.05"
					x2="84.86"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.86"
					y1="506.45"
					x2="88.7"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.7"
					y1="506.45"
					x2="88.7"
					y2="504.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="183.74 514.13 187.58 514.13 187.58 506.45 183.74 506.45 183.74 514.13"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="87.74 514.13 91.58 514.13 91.58 506.45 87.74 506.45 87.74 514.13"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="139.58 506.45 91.58 506.45 91.58 509.81 139.58 509.81 139.58 506.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="160.7 509.81 112.7 509.81 112.7 513.17 160.7 513.17 160.7 509.81"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="187.58"
					y1="506.45"
					x2="188.06"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.58"
					y1="514.13"
					x2="188.06"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.06"
					y1="506.45"
					x2="188.06"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.74"
					y1="506.45"
					x2="87.26"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.74"
					y1="514.13"
					x2="87.26"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.26"
					y1="506.45"
					x2="87.26"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.74"
					y1="514.13"
					x2="183.74"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.74"
					y1="506.45"
					x2="187.58"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.58"
					y1="506.45"
					x2="187.58"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.58"
					y1="514.13"
					x2="183.74"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.74"
					y1="514.13"
					x2="87.74"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.74"
					y1="506.45"
					x2="91.58"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="91.58"
					y1="506.45"
					x2="91.58"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="91.58"
					y1="514.13"
					x2="87.74"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="139.58"
					y1="506.45"
					x2="139.58"
					y2="509.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="139.58"
					y1="509.81"
					x2="91.58"
					y2="509.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="91.58"
					y1="509.81"
					x2="91.58"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="91.58"
					y1="506.45"
					x2="139.58"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.7"
					y1="509.81"
					x2="160.7"
					y2="513.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.7"
					y1="513.17"
					x2="112.7"
					y2="513.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.7"
					y1="513.17"
					x2="112.7"
					y2="509.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.7"
					y1="509.81"
					x2="160.7"
					y2="509.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.06"
					y1="506.45"
					x2="188.06"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="188.06"
					y1="506.45"
					x2="188.06"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="188.06"
					y1="514.13"
					x2="188.06"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="188.06"
					y1="506.45"
					x2="190.46"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="188.06"
					y1="514.13"
					x2="188.06"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="188.06"
					y1="516.05"
					x2="190.46"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="188.06"
					y1="516.05"
					x2="190.46"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="87.26"
					y1="506.45"
					x2="87.26"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="87.26"
					y1="506.45"
					x2="87.26"
					y2="514.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="87.26"
					y1="514.13"
					x2="87.26"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="87.26"
					y1="506.45"
					x2="84.86"
					y2="506.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="87.26"
					y1="514.13"
					x2="87.26"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="87.26"
					y1="516.05"
					x2="84.86"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="87.26"
					y1="516.05"
					x2="84.86"
					y2="516.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="280.85"
					y1="668.63"
					x2="277.97"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="280.85"
					y1="659.03"
					x2="277.97"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="280.85"
					y1="659.03"
					x2="280.85"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="330.77"
					y1="668.63"
					x2="333.65"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="330.77"
					y1="659.03"
					x2="333.65"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="330.77"
					y1="659.03"
					x2="330.77"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="337.13"
					y1="659.03"
					x2="330.77"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="276.24"
					y1="668.63"
					x2="280.85"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="330.77"
					y1="668.63"
					x2="337.13"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<polyline
					points="329.81 669.59 333.65 669.59 333.65 668.63 329.81 668.63 329.81 669.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="281.81 668.63 277.97 668.63 277.97 669.59 281.81 669.59 281.81 668.63"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="329.81 659.03 333.65 659.03 333.65 658.07 329.81 658.07 329.81 659.03"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="281.81 658.07 277.97 658.07 277.97 659.03 281.81 659.03 281.81 658.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="329.81"
					y1="669.59"
					x2="333.65"
					y2="669.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.65"
					y1="669.59"
					x2="333.65"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.65"
					y1="668.63"
					x2="329.81"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.81"
					y1="668.63"
					x2="329.81"
					y2="669.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.81"
					y1="668.63"
					x2="277.97"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.97"
					y1="668.63"
					x2="277.97"
					y2="669.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.97"
					y1="669.59"
					x2="281.81"
					y2="669.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.81"
					y1="669.59"
					x2="281.81"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.81"
					y1="659.03"
					x2="333.65"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.65"
					y1="659.03"
					x2="333.65"
					y2="658.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.65"
					y1="658.07"
					x2="329.81"
					y2="658.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.81"
					y1="658.07"
					x2="329.81"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.81"
					y1="658.07"
					x2="277.97"
					y2="658.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.97"
					y1="658.07"
					x2="277.97"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.97"
					y1="659.03"
					x2="281.81"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.81"
					y1="659.03"
					x2="281.81"
					y2="658.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="328.85 668.63 330.29 668.63 330.29 659.03 328.85 659.03 328.85 668.63"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="281.33 668.63 282.77 668.63 282.77 659.03 281.33 659.03 281.33 668.63"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="315.35 626.45 282.77 659.03 285.14 661.41 317.73 628.83 315.35 626.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="330.29"
					y1="659.03"
					x2="330.77"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.29"
					y1="668.63"
					x2="330.77"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.77"
					y1="659.03"
					x2="330.77"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.33"
					y1="659.03"
					x2="280.85"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.33"
					y1="668.63"
					x2="280.85"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.85"
					y1="659.03"
					x2="280.85"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.85"
					y1="668.63"
					x2="328.85"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.85"
					y1="659.03"
					x2="330.29"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.29"
					y1="659.03"
					x2="330.29"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.29"
					y1="668.63"
					x2="328.85"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.33"
					y1="668.63"
					x2="281.33"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.33"
					y1="659.03"
					x2="282.77"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.77"
					y1="659.03"
					x2="282.77"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.77"
					y1="668.63"
					x2="281.33"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.35"
					y1="626.45"
					x2="317.73"
					y2="628.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.73"
					y1="628.83"
					x2="285.14"
					y2="661.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.14"
					y1="661.41"
					x2="282.77"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.77"
					y1="659.03"
					x2="315.35"
					y2="626.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.77"
					y1="659.03"
					x2="330.77"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="330.77"
					y1="659.03"
					x2="330.77"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="330.77"
					y1="659.03"
					x2="333.65"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="330.77"
					y1="659.03"
					x2="333.65"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="330.77"
					y1="668.63"
					x2="333.65"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="330.77"
					y1="668.63"
					x2="333.65"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="280.85"
					y1="659.03"
					x2="280.85"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="280.85"
					y1="659.03"
					x2="280.85"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="280.85"
					y1="659.03"
					x2="277.97"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="280.85"
					y1="659.03"
					x2="277.97"
					y2="659.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="280.85"
					y1="668.63"
					x2="277.97"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="280.85"
					y1="668.63"
					x2="277.97"
					y2="668.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="124.26"
					y1="680.91"
					x2="114.66"
					y2="680.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="557.2"
					x2="593.07"
					y2="559.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="591.15"
					y1="557.2"
					x2="593.07"
					y2="557.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="557.2"
					x2="583.47"
					y2="559.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="557.2"
					x2="591.15"
					y2="557.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="467.92"
					x2="593.07"
					y2="465.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="591.15"
					y1="467.92"
					x2="593.07"
					y2="467.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="467.92"
					x2="583.47"
					y2="465.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="467.92"
					x2="591.15"
					y2="467.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="429.29"
					x2="593.07"
					y2="431.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="591.15"
					y1="429.29"
					x2="593.07"
					y2="429.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="429.29"
					x2="583.47"
					y2="431.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="429.29"
					x2="591.15"
					y2="429.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="340.01"
					x2="593.07"
					y2="337.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="591.15"
					y1="340.01"
					x2="593.07"
					y2="340.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="340.01"
					x2="583.47"
					y2="337.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="340.01"
					x2="591.15"
					y2="340.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="560.33"
					x2="593.07"
					y2="557.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="467.92"
					x2="593.07"
					y2="462.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="340.01"
					x2="593.07"
					y2="333.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="557.2"
					x2="583.47"
					y2="560.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<polyline
					points="591.15 469.36 593.07 469.36 593.07 468.4 591.15 468.4 591.15 469.36"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="594.03 469.36 594.03 465.52 593.07 465.52 593.07 469.36 594.03 469.36"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="591.15 556.72 593.07 556.72 593.07 555.76 591.15 555.76 591.15 556.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="593.07 555.76 593.07 559.6 594.03 559.6 594.03 555.76 593.07 555.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="583.47 469.36 583.47 465.52 581.07 465.52 581.07 469.36 583.47 469.36"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="581.07 555.76 581.07 559.6 583.47 559.6 583.47 555.76 581.07 555.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="591.15"
					y1="469.36"
					x2="593.07"
					y2="469.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="469.36"
					x2="593.07"
					y2="468.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="468.39"
					x2="591.15"
					y2="468.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="468.39"
					x2="591.15"
					y2="469.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.03"
					y1="469.36"
					x2="594.03"
					y2="465.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.03"
					y1="465.52"
					x2="593.07"
					y2="465.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="465.52"
					x2="593.07"
					y2="469.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="469.36"
					x2="594.03"
					y2="469.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="556.72"
					x2="593.07"
					y2="556.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="556.72"
					x2="593.07"
					y2="555.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="555.76"
					x2="591.15"
					y2="555.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="555.76"
					x2="591.15"
					y2="556.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="555.76"
					x2="593.07"
					y2="559.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="559.6"
					x2="594.03"
					y2="559.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.03"
					y1="559.6"
					x2="594.03"
					y2="555.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.03"
					y1="555.76"
					x2="593.07"
					y2="555.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="469.36"
					x2="583.47"
					y2="465.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="465.52"
					x2="581.07"
					y2="465.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.07"
					y1="465.52"
					x2="581.07"
					y2="469.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.07"
					y1="469.36"
					x2="583.47"
					y2="469.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.07"
					y1="555.76"
					x2="581.07"
					y2="559.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.07"
					y1="559.6"
					x2="583.47"
					y2="559.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="559.6"
					x2="583.47"
					y2="555.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="555.76"
					x2="581.07"
					y2="555.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="591.15 472.24 591.15 468.4 583.47 468.4 583.47 472.24 591.15 472.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="591.15 556.72 591.15 552.88 583.47 552.88 583.47 556.72 591.15 556.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="583.47 510.64 583.47 552.88 586.84 552.88 586.84 510.64 583.47 510.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="586.84 495.28 586.84 537.52 590.19 537.52 590.19 495.28 586.84 495.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="583.47"
					y1="468.39"
					x2="583.47"
					y2="467.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="468.39"
					x2="591.15"
					y2="467.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="467.92"
					x2="591.15"
					y2="467.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="556.72"
					x2="583.47"
					y2="557.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="556.72"
					x2="591.15"
					y2="557.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="557.2"
					x2="591.15"
					y2="557.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="472.24"
					x2="583.47"
					y2="472.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="472.24"
					x2="583.47"
					y2="468.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="468.39"
					x2="591.15"
					y2="468.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="468.39"
					x2="591.15"
					y2="472.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="556.72"
					x2="583.47"
					y2="556.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="556.72"
					x2="583.47"
					y2="552.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="552.88"
					x2="591.15"
					y2="552.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="552.88"
					x2="591.15"
					y2="556.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="510.64"
					x2="586.84"
					y2="510.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.84"
					y1="510.64"
					x2="586.84"
					y2="552.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.84"
					y1="552.88"
					x2="583.47"
					y2="552.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="552.88"
					x2="583.47"
					y2="510.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.84"
					y1="495.28"
					x2="590.19"
					y2="495.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.19"
					y1="495.28"
					x2="590.19"
					y2="537.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.19"
					y1="537.52"
					x2="586.84"
					y2="537.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.84"
					y1="537.52"
					x2="586.84"
					y2="495.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="467.92"
					x2="591.15"
					y2="467.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="467.92"
					x2="591.15"
					y2="467.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="591.15"
					y1="467.92"
					x2="593.07"
					y2="467.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="467.92"
					x2="583.47"
					y2="465.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="591.15"
					y1="467.92"
					x2="593.07"
					y2="467.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="467.92"
					x2="593.07"
					y2="465.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="467.92"
					x2="593.07"
					y2="465.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="557.2"
					x2="591.15"
					y2="557.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="557.2"
					x2="591.15"
					y2="557.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="591.15"
					y1="557.2"
					x2="593.07"
					y2="557.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="557.2"
					x2="583.47"
					y2="559.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="591.15"
					y1="557.2"
					x2="593.07"
					y2="557.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="557.2"
					x2="593.07"
					y2="559.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="557.2"
					x2="593.07"
					y2="559.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<polyline
					points="591.15 341.45 593.07 341.45 593.07 340.49 591.15 340.49 591.15 341.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="594.03 341.45 594.03 337.61 593.07 337.61 593.07 341.45 594.03 341.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="591.15 428.81 593.07 428.81 593.07 427.85 591.15 427.85 591.15 428.81"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="593.07 427.85 593.07 431.69 594.03 431.69 594.03 427.85 593.07 427.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="583.47 341.45 583.47 337.61 581.07 337.61 581.07 341.45 583.47 341.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="581.07 427.85 581.07 431.69 583.47 431.69 583.47 427.85 581.07 427.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="591.15"
					y1="341.45"
					x2="593.07"
					y2="341.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="341.45"
					x2="593.07"
					y2="340.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="340.49"
					x2="591.15"
					y2="340.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="340.49"
					x2="591.15"
					y2="341.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.03"
					y1="341.45"
					x2="594.03"
					y2="337.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.03"
					y1="337.61"
					x2="593.07"
					y2="337.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="337.61"
					x2="593.07"
					y2="341.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="341.45"
					x2="594.03"
					y2="341.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="428.81"
					x2="593.07"
					y2="428.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="428.81"
					x2="593.07"
					y2="427.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="427.85"
					x2="591.15"
					y2="427.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="427.85"
					x2="591.15"
					y2="428.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="427.85"
					x2="593.07"
					y2="431.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.07"
					y1="431.69"
					x2="594.03"
					y2="431.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.03"
					y1="431.69"
					x2="594.03"
					y2="427.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.03"
					y1="427.85"
					x2="593.07"
					y2="427.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="341.45"
					x2="583.47"
					y2="337.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="337.61"
					x2="581.07"
					y2="337.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.07"
					y1="337.61"
					x2="581.07"
					y2="341.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.07"
					y1="341.45"
					x2="583.47"
					y2="341.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.07"
					y1="427.85"
					x2="581.07"
					y2="431.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.07"
					y1="431.69"
					x2="583.47"
					y2="431.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="431.69"
					x2="583.47"
					y2="427.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="427.85"
					x2="581.07"
					y2="427.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="591.15 344.33 591.15 340.49 583.47 340.49 583.47 344.33 591.15 344.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="591.15 428.81 591.15 424.97 583.47 424.97 583.47 428.81 591.15 428.81"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="583.47 382.73 583.47 424.97 586.84 424.97 586.84 382.73 583.47 382.73"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="586.84 367.37 586.84 409.61 590.19 409.61 590.19 367.37 586.84 367.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="583.47"
					y1="340.49"
					x2="583.47"
					y2="340.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="340.49"
					x2="591.15"
					y2="340.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="340.01"
					x2="591.15"
					y2="340.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="428.81"
					x2="583.47"
					y2="429.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="428.81"
					x2="591.15"
					y2="429.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="429.29"
					x2="591.15"
					y2="429.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="344.33"
					x2="583.47"
					y2="344.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="344.33"
					x2="583.47"
					y2="340.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="340.49"
					x2="591.15"
					y2="340.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="340.49"
					x2="591.15"
					y2="344.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="428.81"
					x2="583.47"
					y2="428.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="428.81"
					x2="583.47"
					y2="424.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="424.97"
					x2="591.15"
					y2="424.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.15"
					y1="424.97"
					x2="591.15"
					y2="428.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="382.73"
					x2="586.84"
					y2="382.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.84"
					y1="382.73"
					x2="586.84"
					y2="424.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.84"
					y1="424.97"
					x2="583.47"
					y2="424.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="424.97"
					x2="583.47"
					y2="382.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.84"
					y1="367.37"
					x2="590.19"
					y2="367.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.19"
					y1="367.37"
					x2="590.19"
					y2="409.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.19"
					y1="409.61"
					x2="586.84"
					y2="409.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.84"
					y1="409.61"
					x2="586.84"
					y2="367.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.47"
					y1="340.01"
					x2="591.15"
					y2="340.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="340.01"
					x2="591.15"
					y2="340.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="591.15"
					y1="340.01"
					x2="593.07"
					y2="340.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="340.01"
					x2="583.47"
					y2="337.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="591.15"
					y1="340.01"
					x2="593.07"
					y2="340.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="340.01"
					x2="593.07"
					y2="337.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="340.01"
					x2="593.07"
					y2="337.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="429.29"
					x2="591.15"
					y2="429.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="429.29"
					x2="591.15"
					y2="429.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="591.15"
					y1="429.29"
					x2="593.07"
					y2="429.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="583.47"
					y1="429.29"
					x2="583.47"
					y2="431.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="591.15"
					y1="429.29"
					x2="593.07"
					y2="429.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="429.29"
					x2="593.07"
					y2="431.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="593.07"
					y1="429.29"
					x2="593.07"
					y2="431.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="934.64"
					y1="563.69"
					x2="917.11"
					y2="563.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="917.11"
					y1="563.69"
					x2="917.11"
					y2="573.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="917.11"
					y1="573.29"
					x2="917.11"
					y2="709.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="917.11"
					y1="709.72"
					x2="742.54"
					y2="709.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="742.54"
					y1="709.72"
					x2="742.54"
					y2="719.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="742.54"
					y1="719.33"
					x2="742.54"
					y2="731.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="703.82"
					y1="270.18"
					x2="703.82"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="541.56"
					y1="254.82"
					x2="541.56"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<line
					x1="853.45"
					y1="254.82"
					x2="853.45"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".3"
				/>
				<polyline
					points="746.81 665.91 746.81 709.72 789.87 709.72 789.87 665.91 746.81 665.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="789.87"
					y1="665.91"
					x2="788.15"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.39"
					y1="665.91"
					x2="780.78"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.02"
					y1="665.91"
					x2="773.41"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.64"
					y1="665.91"
					x2="766.03"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.27"
					y1="665.91"
					x2="758.66"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.9"
					y1="665.91"
					x2="751.29"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.52"
					y1="665.91"
					x2="746.81"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.87"
					y1="709.72"
					x2="789.87"
					y2="707.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.87"
					y1="704.87"
					x2="789.87"
					y2="700.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.87"
					y1="697.5"
					x2="789.87"
					y2="692.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.87"
					y1="690.12"
					x2="789.87"
					y2="685.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.87"
					y1="682.75"
					x2="789.87"
					y2="678.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.87"
					y1="675.38"
					x2="789.87"
					y2="670.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.87"
					y1="668.01"
					x2="789.87"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.81"
					y1="709.72"
					x2="748.52"
					y2="709.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.29"
					y1="709.72"
					x2="755.9"
					y2="709.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.66"
					y1="709.72"
					x2="763.27"
					y2="709.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.03"
					y1="709.72"
					x2="770.64"
					y2="709.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.41"
					y1="709.72"
					x2="778.02"
					y2="709.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.78"
					y1="709.72"
					x2="785.39"
					y2="709.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.15"
					y1="709.72"
					x2="789.87"
					y2="709.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.81"
					y1="665.91"
					x2="746.81"
					y2="668.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.81"
					y1="670.77"
					x2="746.81"
					y2="675.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.81"
					y1="678.14"
					x2="746.81"
					y2="682.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.81"
					y1="685.52"
					x2="746.81"
					y2="690.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.81"
					y1="692.89"
					x2="746.81"
					y2="697.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.81"
					y1="700.26"
					x2="746.81"
					y2="704.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.81"
					y1="707.64"
					x2="746.81"
					y2="709.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="789.7 663.65 789.7 662.32 746.97 662.32 746.97 663.65 753.67 663.65 753.67 662.56 783 662.56 783 663.65 789.7 663.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="783"
					y1="663.65"
					x2="789.7"
					y2="663.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="783"
					y1="662.56"
					x2="783"
					y2="663.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="753.67"
					y1="662.56"
					x2="783"
					y2="662.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="753.67"
					y1="663.65"
					x2="753.67"
					y2="662.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="746.97"
					y1="663.65"
					x2="753.67"
					y2="663.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="746.97"
					y1="662.32"
					x2="746.97"
					y2="663.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="789.7"
					y1="662.32"
					x2="746.97"
					y2="662.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="789.7"
					y1="663.65"
					x2="789.7"
					y2="662.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<polyline
					points="791.38 663.65 745.3 663.65 745.3 665.91 791.38 665.91 791.38 663.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="791.38"
					y1="665.91"
					x2="791.38"
					y2="663.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="745.3"
					y1="665.91"
					x2="791.38"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="745.3"
					y1="663.65"
					x2="745.3"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="791.38"
					y1="663.65"
					x2="745.3"
					y2="663.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="746.97"
					y1="663.65"
					x2="746.97"
					y2="662.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.97"
					y1="662.32"
					x2="789.7"
					y2="662.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.7"
					y1="662.32"
					x2="789.7"
					y2="663.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.3"
					y1="663.65"
					x2="791.38"
					y2="663.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783"
					y1="663.65"
					x2="783"
					y2="662.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783"
					y1="662.56"
					x2="753.67"
					y2="662.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.67"
					y1="662.56"
					x2="753.67"
					y2="663.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.3"
					y1="665.91"
					x2="745.3"
					y2="663.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.38"
					y1="663.65"
					x2="791.38"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.38"
					y1="665.91"
					x2="745.3"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="863.29 500.96 863.29 563.69 934.64 563.69 934.64 500.96 863.29 500.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="934.64"
					y1="500.96"
					x2="863.29"
					y2="500.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.64"
					y1="563.69"
					x2="934.64"
					y2="500.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.29"
					y1="563.69"
					x2="934.64"
					y2="563.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.29"
					y1="500.96"
					x2="863.29"
					y2="563.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.08"
					y1="500.96"
					x2="868.08"
					y2="563.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="867.19 584.03 867.19 641.63 917.11 641.63 917.11 584.03 867.19 584.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="867.19"
					y1="584.03"
					x2="867.19"
					y2="641.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.11"
					y1="584.03"
					x2="917.11"
					y2="641.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="915.6"
					y1="584.03"
					x2="915.6"
					y2="641.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="867.19"
					y1="584.03"
					x2="917.11"
					y2="584.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="867.19"
					y1="641.63"
					x2="917.11"
					y2="641.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.46"
					y1="587.81"
					x2="869.46"
					y2="637.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.46"
					y1="637.85"
					x2="870.97"
					y2="639.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.97"
					y1="639.36"
					x2="913.33"
					y2="639.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.33"
					y1="639.36"
					x2="914.84"
					y2="637.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.84"
					y1="637.85"
					x2="914.84"
					y2="587.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.84"
					y1="587.81"
					x2="913.33"
					y2="586.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.33"
					y1="586.3"
					x2="870.97"
					y2="586.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.97"
					y1="586.3"
					x2="869.46"
					y2="587.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m887.23,598.43c0-4.17-3.38-7.56-7.56-7.56s-7.56,3.39-7.56,7.56,3.39,7.56,7.56,7.56,7.56-3.39,7.56-7.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m910.3,598.43c0-3.13-2.54-5.67-5.67-5.67s-5.67,2.54-5.67,5.67,2.54,5.67,5.67,5.67,5.67-2.54,5.67-5.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m885.34,627.23c0-3.13-2.54-5.67-5.67-5.67s-5.67,2.54-5.67,5.67,2.54,5.67,5.67,5.67,5.67-2.54,5.67-5.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m912.19,627.23c0-4.18-3.38-7.56-7.56-7.56s-7.56,3.38-7.56,7.56,3.38,7.56,7.56,7.56,7.56-3.39,7.56-7.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="839.68 667.48 799.87 667.48 798.79 667.93 798.35 669 798.35 708.21 798.79 709.28 799.87 709.72 839.68 709.72 840.74 709.28 841.19 708.21 841.19 669 840.74 667.93 839.68 667.48"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m839.68,667.48c.84,0,1.51.68,1.51,1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.19"
					y1="708.21"
					x2="841.19"
					y2="669"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m841.19,708.21c0,.84-.68,1.51-1.51,1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.87"
					y1="709.72"
					x2="839.68"
					y2="709.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m799.87,709.72c-.84,0-1.51-.68-1.51-1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.35"
					y1="669"
					x2="798.35"
					y2="708.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m798.35,669c0-.84.68-1.51,1.51-1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.68"
					y1="667.48"
					x2="799.87"
					y2="667.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.89"
					y1="671.27"
					x2="803.64"
					y2="671.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.13"
					y1="672.78"
					x2="802.13"
					y2="700.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.64"
					y1="702.17"
					x2="835.89"
					y2="702.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.41"
					y1="700.65"
					x2="837.41"
					y2="672.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.89"
					y1="671.27"
					x2="835.89"
					y2="671.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m802.13,672.78c0-.84.68-1.51,1.51-1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m803.64,702.17c-.84,0-1.51-.68-1.51-1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m837.41,700.65c0,.84-.68,1.51-1.51,1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m835.89,671.27c.84,0,1.51.68,1.51,1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m822.04,694.61c0-1.25-1.02-2.27-2.27-2.27s-2.27,1.01-2.27,2.27,1.01,2.27,2.27,2.27,2.27-1.02,2.27-2.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="820.45 692.5 820.25 692.02 819.77 691.82 819.29 692.02 819.09 692.5 819.09 707.46 819.29 707.94 819.77 708.14 820.25 707.94 820.45 707.46 820.45 692.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="820.45"
					y1="707.46"
					x2="820.45"
					y2="692.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m820.45,707.46c0,.38-.3.68-.68.68s-.68-.3-.68-.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.09"
					y1="692.5"
					x2="819.09"
					y2="707.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m819.09,692.5h0c0-.38.3-.68.68-.68s.68.3.68.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="821.28 703.6 820.45 703.6 820.45 707.46 820.25 707.94 819.77 708.14 819.29 707.94 819.09 707.46 819.09 703.6 818.26 703.6 818.26 708.52 821.28 708.52 821.28 703.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="821.28"
					y1="708.52"
					x2="821.28"
					y2="703.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.26"
					y1="708.52"
					x2="821.28"
					y2="708.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.26"
					y1="703.6"
					x2="818.26"
					y2="708.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.09"
					y1="703.6"
					x2="818.26"
					y2="703.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.09"
					y1="707.46"
					x2="819.09"
					y2="703.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m820.45,707.46c0,.38-.3.68-.68.68s-.68-.3-.68-.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.45"
					y1="703.6"
					x2="820.45"
					y2="707.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="821.28"
					y1="703.6"
					x2="820.45"
					y2="703.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="821.26 700.88 820.45 700.88 820.45 703.53 821.26 703.53 821.26 700.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="821.26"
					y1="703.53"
					x2="821.26"
					y2="700.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.45"
					y1="703.53"
					x2="821.26"
					y2="703.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.45"
					y1="700.88"
					x2="820.45"
					y2="703.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="821.26"
					y1="700.88"
					x2="820.45"
					y2="700.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="818.28 700.88 818.28 703.53 819.09 703.53 819.09 700.88 818.28 700.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="819.09"
					y1="700.88"
					x2="818.28"
					y2="700.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.09"
					y1="703.53"
					x2="819.09"
					y2="700.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.28"
					y1="703.53"
					x2="819.09"
					y2="703.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.28"
					y1="700.88"
					x2="818.28"
					y2="703.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="216.32 648.97 212.89 647.44 209.18 646.91 205.46 647.44 202.03 648.97 199.78 650.91 198.07 653.34 195.89 659.06 195.12 663.8 195.41 668.6 196.74 673.22 196.63 677.44 195.56 681.53 193.59 685.27 192.55 686.89 191.33 690.23 191.52 693.77 192.07 695.18 192.07 698.9 193.62 698.9 193.62 697.2 196.22 698.78 199.2 699.39 219.15 699.39 222.1 698.79 224.62 697.16 226.38 694.72 227.14 691.81 227.14 691.35 226.74 688.95 224.72 685.18 222.76 681.49 221.7 677.44 221.59 673.26 222.94 668.63 223.23 663.82 222.46 659.06 220.29 653.34 218.57 650.91 216.32 648.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="202.07"
					y1="681.66"
					x2="216.28"
					y2="681.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.15"
					y1="699.39"
					x2="209.18"
					y2="699.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.15"
					y1="698.67"
					x2="209.18"
					y2="698.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.2"
					y1="699.39"
					x2="209.18"
					y2="699.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.2"
					y1="698.67"
					x2="209.18"
					y2="698.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.91"
					y1="681.66"
					x2="215.91"
					y2="684.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.91"
					y1="684.31"
					x2="213.72"
					y2="684.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.72"
					y1="684.31"
					x2="213.72"
					y2="681.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.44"
					y1="681.66"
					x2="202.44"
					y2="684.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.44"
					y1="684.31"
					x2="204.63"
					y2="684.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.63"
					y1="684.31"
					x2="204.63"
					y2="681.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.62"
					y1="692.3"
					x2="193.62"
					y2="698.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.07"
					y1="692.3"
					x2="192.07"
					y2="698.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.07"
					y1="698.9"
					x2="193.62"
					y2="698.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.07"
					y1="692.3"
					x2="193.62"
					y2="692.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.18"
					y1="646.91"
					x2="211.56"
					y2="647.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.56"
					y1="647.18"
					x2="213.86"
					y2="647.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.86"
					y1="647.79"
					x2="216.32"
					y2="648.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.32"
					y1="648.97"
					x2="218.58"
					y2="650.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.58"
					y1="650.91"
					x2="220.29"
					y2="653.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.29"
					y1="653.34"
					x2="221.55"
					y2="656.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.55"
					y1="656.11"
					x2="222.46"
					y2="659.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.46"
					y1="659.06"
					x2="223.29"
					y2="663.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.29"
					y1="663.81"
					x2="223.33"
					y2="666.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.33"
					y1="666.21"
					x2="223.07"
					y2="668.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.07"
					y1="668.6"
					x2="221.99"
					y2="672.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.99"
					y1="672.3"
					x2="220.31"
					y2="675.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.31"
					y1="675.89"
					x2="218.31"
					y2="679.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.31"
					y1="679.1"
					x2="216.28"
					y2="681.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.59"
					y1="673.26"
					x2="221.61"
					y2="676.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.61"
					y1="676.59"
					x2="222.16"
					y2="679.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.16"
					y1="679.83"
					x2="223.54"
					y2="683.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.54"
					y1="683.3"
					x2="225.14"
					y2="685.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.14"
					y1="685.82"
					x2="226.56"
					y2="688.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.56"
					y1="688.42"
					x2="227.12"
					y2="690.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.12"
					y1="690.96"
					x2="226.91"
					y2="693.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.91"
					y1="693.5"
					x2="225.92"
					y2="695.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.92"
					y1="695.8"
					x2="224.18"
					y2="697.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.18"
					y1="697.65"
					x2="222.48"
					y2="698.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.48"
					y1="698.59"
					x2="220.85"
					y2="699.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.85"
					y1="699.12"
					x2="219.15"
					y2="699.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.15"
					y1="698.67"
					x2="221.48"
					y2="698.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.48"
					y1="698.11"
					x2="222.86"
					y2="696.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.86"
					y1="696.94"
					x2="223.73"
					y2="695.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.73"
					y1="695.32"
					x2="224.14"
					y2="693.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.14"
					y1="693.18"
					x2="224.24"
					y2="690.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.24"
					y1="690.97"
					x2="224.23"
					y2="689.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.23"
					y1="689.87"
					x2="223.76"
					y2="689"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.76"
					y1="689"
					x2="223.22"
					y2="688.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.22"
					y1="688.75"
					x2="217.19"
					y2="687.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.19"
					y1="687.04"
					x2="214.19"
					y2="686.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.19"
					y1="686.53"
					x2="211.16"
					y2="686.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.16"
					y1="686.31"
					x2="209.18"
					y2="686.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.74"
					y1="673.22"
					x2="196.71"
					y2="676.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.71"
					y1="676.55"
					x2="196.17"
					y2="679.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.17"
					y1="679.81"
					x2="194.81"
					y2="683.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.81"
					y1="683.3"
					x2="191.8"
					y2="688.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.8"
					y1="688.42"
					x2="191.33"
					y2="690.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.33"
					y1="690.12"
					x2="191.22"
					y2="691.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.22"
					y1="691.86"
					x2="191.46"
					y2="693.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.46"
					y1="693.57"
					x2="192.07"
					y2="695.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.2"
					y1="698.67"
					x2="196.87"
					y2="698.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.87"
					y1="698.11"
					x2="195.49"
					y2="696.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.49"
					y1="696.94"
					x2="194.62"
					y2="695.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.62"
					y1="695.32"
					x2="194.21"
					y2="693.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.21"
					y1="693.18"
					x2="194.11"
					y2="690.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.11"
					y1="690.97"
					x2="194.13"
					y2="689.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.13"
					y1="689.87"
					x2="194.59"
					y2="689"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.59"
					y1="689"
					x2="195.13"
					y2="688.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.13"
					y1="688.75"
					x2="201.16"
					y2="687.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.16"
					y1="687.04"
					x2="204.16"
					y2="686.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.16"
					y1="686.53"
					x2="207.19"
					y2="686.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.19"
					y1="686.31"
					x2="209.18"
					y2="686.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.18"
					y1="646.91"
					x2="206.79"
					y2="647.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.79"
					y1="647.18"
					x2="204.49"
					y2="647.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.49"
					y1="647.79"
					x2="202.03"
					y2="648.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.03"
					y1="648.97"
					x2="199.78"
					y2="650.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.78"
					y1="650.91"
					x2="198.07"
					y2="653.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.07"
					y1="653.34"
					x2="196.8"
					y2="656.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.8"
					y1="656.11"
					x2="195.89"
					y2="659.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.89"
					y1="659.06"
					x2="195.06"
					y2="663.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.06"
					y1="663.81"
					x2="195.02"
					y2="666.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.02"
					y1="666.21"
					x2="195.29"
					y2="668.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.29"
					y1="668.6"
					x2="196.37"
					y2="672.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.37"
					y1="672.3"
					x2="198.05"
					y2="675.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.05"
					y1="675.89"
					x2="200.04"
					y2="679.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.04"
					y1="679.1"
					x2="202.07"
					y2="681.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.89"
					y1="687.04"
					x2="225.51"
					y2="686.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.51"
					y1="686.5"
					x2="224.41"
					y2="685.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.41"
					y1="685.69"
					x2="223.46"
					y2="685.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.46"
					y1="685.5"
					x2="217.33"
					y2="684.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.33"
					y1="684.97"
					x2="211.19"
					y2="684.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.19"
					y1="684.74"
					x2="209.18"
					y2="684.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.46"
					y1="687.04"
					x2="192.85"
					y2="686.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.85"
					y1="686.5"
					x2="193.94"
					y2="685.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.94"
					y1="685.69"
					x2="194.89"
					y2="685.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.89"
					y1="685.5"
					x2="201.02"
					y2="684.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.02"
					y1="684.97"
					x2="207.16"
					y2="684.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.16"
					y1="684.74"
					x2="209.18"
					y2="684.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.62"
					y1="697.2"
					x2="194.17"
					y2="697.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.17"
					y1="697.65"
					x2="195.87"
					y2="698.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.87"
					y1="698.59"
					x2="197.5"
					y2="699.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.5"
					y1="699.12"
					x2="199.2"
					y2="699.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="178.61"
					y1="661.92"
					x2="124.26"
					y2="661.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="178.61"
					y1="661.92"
					x2="178.61"
					y2="699.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="170.63"
					y1="670.58"
					x2="132.23"
					y2="670.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.23"
					y1="670.58"
					x2="132.23"
					y2="693.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.23"
					y1="693.62"
					x2="170.63"
					y2="693.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="170.63"
					y1="693.62"
					x2="170.63"
					y2="670.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.15"
					y1="669.06"
					x2="130.72"
					y2="669.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.72"
					y1="669.06"
					x2="130.72"
					y2="695.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.72"
					y1="695.13"
					x2="172.15"
					y2="695.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.15"
					y1="695.13"
					x2="172.15"
					y2="669.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m153.7,688.41c0-1.25-1.02-2.27-2.27-2.27s-2.27,1.01-2.27,2.27,1.02,2.27,2.27,2.27,2.27-1.02,2.27-2.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="153.32 697.6 153.02 694.43 152.77 693.71 152.27 689.71 151.99 689.18 151.43 688.97 150.87 689.18 150.59 689.71 150.09 693.71 149.85 694.43 149.54 697.6 149.9 698.71 150.85 699.4 152.02 699.4 152.96 698.71 153.32 697.6"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m153.32,697.6c0,1.04-.85,1.89-1.89,1.89s-1.89-.85-1.89-1.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="149.85"
					y1="694.43"
					x2="149.54"
					y2="697.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m149.85,694.43c.02-.26.11-.5.25-.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.59"
					y1="689.71"
					x2="150.09"
					y2="693.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m150.59,689.71c.05-.42.41-.74.84-.74s.79.32.84.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="152.77"
					y1="693.71"
					x2="152.27"
					y2="689.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m152.77,693.71c.14.22.22.46.25.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="153.32"
					y1="697.6"
					x2="153.02"
					y2="694.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.41"
					y1="695.72"
					x2="150.41"
					y2="694.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="152.46"
					y1="694.59"
					x2="152.46"
					y2="695.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="152.46"
					y1="695.72"
					x2="150.41"
					y2="695.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m150.41,694.59c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m150.09,693.71c.29-.46.8-.73,1.34-.73s1.05.28,1.34.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="232.22 699.39 232.22 698.62 228.38 698.62 228.38 699.39 232.22 699.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="228.38"
					y1="699.39"
					x2="232.22"
					y2="699.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.38"
					y1="698.62"
					x2="228.38"
					y2="699.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.22"
					y1="698.62"
					x2="228.38"
					y2="698.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.22"
					y1="699.39"
					x2="232.22"
					y2="698.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="186.14 699.39 189.98 699.39 189.98 698.62 186.14 698.62 186.14 699.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="186.14"
					y1="698.62"
					x2="186.14"
					y2="699.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.98"
					y1="698.62"
					x2="186.14"
					y2="698.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.98"
					y1="699.39"
					x2="189.98"
					y2="698.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.14"
					y1="699.39"
					x2="189.98"
					y2="699.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="230.68 698.62 230.68 692.37 229.91 692.37 229.91 698.62 230.68 698.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="229.91"
					y1="698.62"
					x2="230.68"
					y2="698.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.91"
					y1="692.37"
					x2="229.91"
					y2="698.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.68"
					y1="692.37"
					x2="229.91"
					y2="692.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.68"
					y1="698.62"
					x2="230.68"
					y2="692.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="187.67 698.62 188.44 698.62 188.44 692.37 187.67 692.37 187.67 698.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="187.67"
					y1="692.37"
					x2="187.67"
					y2="698.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.44"
					y1="692.37"
					x2="187.67"
					y2="692.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.44"
					y1="698.62"
					x2="188.44"
					y2="692.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.67"
					y1="698.62"
					x2="188.44"
					y2="698.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="229.91 694.29 229.91 692.76 188.44 692.76 188.44 694.29 229.91 694.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="188.44"
					y1="694.29"
					x2="229.91"
					y2="694.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.44"
					y1="692.76"
					x2="188.44"
					y2="694.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.91"
					y1="692.76"
					x2="188.44"
					y2="692.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.91"
					y1="694.29"
					x2="229.91"
					y2="692.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.26"
					y1="680.91"
					x2="124.26"
					y2="569.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="72.34 673.96 116.51 673.96 116.51 577.36 72.34 577.36 72.34 673.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="72.34"
					y1="577.36"
					x2="72.34"
					y2="673.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.51"
					y1="577.36"
					x2="72.34"
					y2="577.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.51"
					y1="673.96"
					x2="116.51"
					y2="577.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="72.34"
					y1="673.96"
					x2="116.51"
					y2="673.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="94.81 664.46 94.41 664.5 94.03 664.59 93.67 664.75 93.34 664.96 93.06 665.22 92.83 665.52 92.66 665.86 92.56 666.21 92.53 666.58 92.56 666.95 92.66 667.31 92.83 667.64 93.06 667.94 93.34 668.21 93.67 668.42 94.03 668.57 94.41 668.67 94.81 668.7 95.21 668.67 95.59 668.57 95.95 668.42 96.28 668.21 96.56 667.94 96.79 667.64 96.96 667.31 97.06 666.95 97.09 666.58 97.06 666.21 96.96 665.86 96.79 665.52 96.56 665.22 96.28 664.96 95.95 664.75 95.59 664.59 95.21 664.5 94.81 664.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="95.21"
					y1="664.5"
					x2="94.81"
					y2="664.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.59"
					y1="664.59"
					x2="95.21"
					y2="664.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.95"
					y1="664.75"
					x2="95.59"
					y2="664.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.28"
					y1="664.96"
					x2="95.95"
					y2="664.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.56"
					y1="665.22"
					x2="96.28"
					y2="664.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.79"
					y1="665.52"
					x2="96.56"
					y2="665.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.96"
					y1="665.86"
					x2="96.79"
					y2="665.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="97.06"
					y1="666.21"
					x2="96.96"
					y2="665.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="97.09"
					y1="666.58"
					x2="97.06"
					y2="666.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="97.06"
					y1="666.95"
					x2="97.09"
					y2="666.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.96"
					y1="667.31"
					x2="97.06"
					y2="666.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.79"
					y1="667.64"
					x2="96.96"
					y2="667.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.56"
					y1="667.94"
					x2="96.79"
					y2="667.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.28"
					y1="668.21"
					x2="96.56"
					y2="667.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.95"
					y1="668.42"
					x2="96.28"
					y2="668.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.59"
					y1="668.57"
					x2="95.95"
					y2="668.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.21"
					y1="668.67"
					x2="95.59"
					y2="668.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.81"
					y1="668.7"
					x2="95.21"
					y2="668.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.41"
					y1="668.67"
					x2="94.81"
					y2="668.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.03"
					y1="668.57"
					x2="94.41"
					y2="668.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.67"
					y1="668.42"
					x2="94.03"
					y2="668.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.34"
					y1="668.21"
					x2="93.67"
					y2="668.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.06"
					y1="667.94"
					x2="93.34"
					y2="668.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.83"
					y1="667.64"
					x2="93.06"
					y2="667.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.66"
					y1="667.31"
					x2="92.83"
					y2="667.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.56"
					y1="666.95"
					x2="92.66"
					y2="667.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.53"
					y1="666.58"
					x2="92.56"
					y2="666.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.56"
					y1="666.21"
					x2="92.53"
					y2="666.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.66"
					y1="665.86"
					x2="92.56"
					y2="666.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.83"
					y1="665.52"
					x2="92.66"
					y2="665.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.06"
					y1="665.22"
					x2="92.83"
					y2="665.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.34"
					y1="664.96"
					x2="93.06"
					y2="665.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.67"
					y1="664.75"
					x2="93.34"
					y2="664.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.03"
					y1="664.59"
					x2="93.67"
					y2="664.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.41"
					y1="664.5"
					x2="94.03"
					y2="664.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.81"
					y1="664.46"
					x2="94.41"
					y2="664.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="96.78 676.43 96.75 676.75 96.66 677.06 96.52 677.35 96.32 677.61 96.08 677.84 95.8 678.02 95.49 678.15 95.15 678.23 94.81 678.26 94.47 678.23 94.14 678.15 93.83 678.02 93.54 677.84 93.3 677.61 93.1 677.35 92.96 677.06 92.87 676.75 92.84 676.43 93.16 673.37 93.2 673.12 93.29 672.89 93.41 672.67 93.94 668.8 93.97 668.66 94.02 668.53 94.1 668.42 94.2 668.31 94.32 668.22 94.45 668.16 94.59 668.11 94.74 668.09 94.89 668.09 95.03 668.11 95.18 668.16 95.31 668.22 95.42 668.31 95.52 668.42 95.6 668.53 95.65 668.66 95.69 668.8 96.21 672.67 96.33 672.89 96.42 673.12 96.47 673.37 96.78 676.43"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="96.78"
					y1="676.43"
					x2="96.47"
					y2="673.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.21"
					y1="672.67"
					x2="95.69"
					y2="668.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.94"
					y1="668.8"
					x2="93.41"
					y2="672.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.16"
					y1="673.37"
					x2="92.84"
					y2="676.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.74"
					y1="674.61"
					x2="93.74"
					y2="673.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.88"
					y1="673.52"
					x2="95.88"
					y2="674.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.88"
					y1="674.61"
					x2="93.74"
					y2="674.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m96.21,672.67c.15.21.23.45.26.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m93.94,668.8c.06-.41.43-.71.87-.71s.82.3.88.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m93.16,673.37c.02-.25.11-.49.26-.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m96.78,676.43c0,1.01-.88,1.83-1.97,1.83s-1.97-.82-1.97-1.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m93.74,673.52c0-.55.48-.99,1.07-.99s1.07.44,1.07.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m93.41,672.67c.31-.44.83-.71,1.4-.71s1.09.27,1.4.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.39"
					y1="691.04"
					x2="325.39"
					y2="677.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.39"
					y1="677.6"
					x2="288.91"
					y2="677.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.07"
					y1="691.04"
					x2="281.23"
					y2="691.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.23"
					y1="725.6"
					x2="333.07"
					y2="725.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.07"
					y1="725.6"
					x2="333.07"
					y2="673.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.23"
					y1="673.77"
					x2="281.23"
					y2="725.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.07"
					y1="674.72"
					x2="281.23"
					y2="674.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.91"
					y1="691.04"
					x2="288.91"
					y2="677.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.07"
					y1="673.77"
					x2="281.23"
					y2="673.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.29"
					y1="561.77"
					x2="859.49"
					y2="561.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.49"
					y1="561.77"
					x2="859.49"
					y2="559.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.49"
					y1="559.85"
					x2="863.29"
					y2="559.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.03"
					y1="500.96"
					x2="871.03"
					y2="505.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.03"
					y1="507.9"
					x2="871.03"
					y2="512.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.03"
					y1="515.28"
					x2="871.03"
					y2="519.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.03"
					y1="522.65"
					x2="871.03"
					y2="527.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.03"
					y1="530.02"
					x2="871.03"
					y2="534.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.03"
					y1="537.39"
					x2="871.03"
					y2="542"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.03"
					y1="544.77"
					x2="871.03"
					y2="549.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.03"
					y1="552.14"
					x2="871.03"
					y2="556.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.03"
					y1="559.51"
					x2="871.03"
					y2="563.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="686.69"
					x2="889.73"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.96"
					y1="686.69"
					x2="882.36"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.59"
					y1="686.69"
					x2="874.98"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.22"
					y1="686.69"
					x2="867.61"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.85"
					y1="686.69"
					x2="860.24"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.47"
					y1="686.69"
					x2="852.87"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="850.1"
					y1="686.69"
					x2="845.49"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.73"
					y1="686.69"
					x2="838.12"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.35"
					y1="686.69"
					x2="830.75"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="827.98"
					y1="686.69"
					x2="823.37"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.61"
					y1="686.69"
					x2="816"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.24"
					y1="686.69"
					x2="808.63"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="805.86"
					y1="686.69"
					x2="801.25"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.49"
					y1="686.69"
					x2="793.88"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.12"
					y1="686.69"
					x2="786.51"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.74"
					y1="686.69"
					x2="779.13"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.37"
					y1="686.69"
					x2="771.76"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769"
					y1="686.69"
					x2="764.39"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.62"
					y1="686.69"
					x2="757.02"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.25"
					y1="686.69"
					x2="749.64"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.88"
					y1="686.69"
					x2="742.54"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.03"
					y1="663.65"
					x2="742.54"
					y2="663.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="563.69"
					x2="894.07"
					y2="568.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="571.27"
					x2="894.07"
					y2="575.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="578.65"
					x2="894.07"
					y2="583.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="586.02"
					x2="894.07"
					y2="590.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="593.39"
					x2="894.07"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="600.76"
					x2="894.07"
					y2="605.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="608.14"
					x2="894.07"
					y2="612.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="615.51"
					x2="894.07"
					y2="620.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="622.88"
					x2="894.07"
					y2="627.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="630.26"
					x2="894.07"
					y2="634.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="637.63"
					x2="894.07"
					y2="642.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="645"
					x2="894.07"
					y2="649.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="652.38"
					x2="894.07"
					y2="656.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="659.75"
					x2="894.07"
					y2="664.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="667.12"
					x2="894.07"
					y2="671.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="674.5"
					x2="894.07"
					y2="679.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.07"
					y1="681.87"
					x2="894.07"
					y2="686.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.03"
					y1="563.69"
					x2="871.03"
					y2="584.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.54"
					y1="663.65"
					x2="742.54"
					y2="709.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.03"
					y1="641.63"
					x2="871.03"
					y2="663.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.69"
					y1="254.82"
					x2="541.56"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.56"
					y1="270.18"
					x2="412.78"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.82"
					y1="254.82"
					x2="853.45"
					y2="254.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.45"
					y1="270.18"
					x2="703.82"
					y2="270.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.39"
					y1="719.84"
					x2="288.91"
					y2="719.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.91"
					y1="719.84"
					x2="288.91"
					y2="694.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.91"
					y1="694.89"
					x2="325.39"
					y2="694.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.39"
					y1="694.89"
					x2="325.39"
					y2="719.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="512.25 560.33 512.25 569.93 350.9 569.93 350.9 560.33 362.04 560.33 362.04 270.18 192.9 270.18 192.9 254.82 412.79 254.82 412.79 270.18 371.63 270.18 371.63 560.33 512.25 560.33"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.08"
				/>
				<polygon
					points="351.28 731.74 351.28 747.1 50 747.1 50 254.82 134.34 254.82 134.34 270.18 109.27 270.18 109.27 332.09 65.37 332.09 65.37 506.45 87.27 506.45 87.27 516.05 65.37 516.05 65.37 560.33 204.4 560.33 204.4 516.05 188.06 516.05 188.06 506.45 214.01 506.45 214.01 560.33 289.46 560.33 289.46 569.93 251.21 569.93 251.21 580.63 241.62 580.63 241.62 569.93 65.37 569.93 65.37 680.91 124.26 680.91 124.26 699.39 241.62 699.39 241.62 642.07 251.21 642.07 251.21 659.03 280.85 659.03 280.85 668.63 276.24 668.63 276.24 731.74 337.13 731.74 337.13 668.63 330.77 668.63 330.77 659.03 346.72 659.03 346.72 731.74 351.28 731.74"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.08"
				/>
				<polygon
					points="703.82 254.82 703.82 270.18 648.11 270.18 648.11 569.93 573.69 569.93 573.69 560.33 583.48 560.33 583.48 557.19 593.07 557.19 593.07 560.33 638.52 560.33 638.52 462.64 593.07 462.64 593.07 467.91 583.48 467.91 583.48 429.29 593.07 429.29 593.07 453.04 638.52 453.04 638.52 333.68 593.07 333.68 593.07 340.01 583.48 340.01 583.48 270.18 541.57 270.18 541.57 254.82 703.82 254.82"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.08"
				/>
				<polygon
					points="950 254.82 950 747.1 424.24 747.1 424.24 731.74 742.54 731.74 742.54 709.72 917.11 709.72 917.11 563.69 934.63 563.69 934.63 270.18 853.45 270.18 853.45 254.82 950 254.82"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.08"
				/>
			</g>
			<g id="text">
				<path d="m758.93,681.36v-8.9h3.07c.69,0,1.22.04,1.58.13.51.12.95.33,1.31.64.47.4.82.9,1.05,1.52.23.62.35,1.32.35,2.11,0,.68-.08,1.27-.24,1.8-.16.52-.36.96-.61,1.3-.25.34-.52.61-.81.81-.29.19-.65.34-1.06.44-.41.1-.89.15-1.43.15h-3.21Zm1.18-1.05h1.9c.59,0,1.05-.05,1.38-.16.34-.11.6-.26.8-.46.28-.28.5-.65.65-1.12.16-.47.24-1.05.24-1.72,0-.93-.15-1.65-.46-2.14-.3-.5-.67-.84-1.11-1.01-.32-.12-.82-.18-1.52-.18h-1.87v6.8Zm9.36,1.05l-2.36-8.9h1.21l1.35,5.83c.15.61.27,1.22.38,1.82.23-.95.36-1.5.4-1.65l1.69-6.01h1.42l1.27,4.5c.32,1.12.55,2.17.69,3.15.11-.56.26-1.21.44-1.94l1.4-5.72h1.18l-2.44,8.9h-1.14l-1.88-6.78c-.16-.57-.25-.91-.28-1.04-.09.41-.18.76-.26,1.04l-1.89,6.78h-1.2Z" />
				<path d="m896.15,537.66h-1.25l-1.5-2.51c-.14-.23-.27-.43-.4-.59-.13-.17-.26-.3-.4-.41-.13-.1-.28-.18-.44-.23-.15-.05-.33-.08-.53-.08h-.86v3.81h-1.05v-8.97h2.68c.39,0,.75.05,1.08.15.33.1.62.24.86.44.25.2.44.45.58.75.14.3.21.64.21,1.04,0,.31-.05.6-.14.86-.09.26-.23.49-.4.69-.17.2-.38.38-.63.53-.24.14-.51.25-.82.33v.03c.15.07.28.14.39.23.11.08.22.18.32.3.1.12.2.25.29.4.1.15.21.32.33.51l1.68,2.7Zm-5.38-8.02v3.25h1.43c.26,0,.5-.04.73-.12.23-.08.42-.19.58-.34.16-.15.29-.33.38-.54.09-.22.14-.46.14-.73,0-.48-.16-.85-.47-1.12-.31-.27-.76-.41-1.34-.41h-1.44Zm11.5,5.07h-4.52c.02.71.21,1.26.58,1.65.37.39.87.58,1.51.58.72,0,1.38-.24,1.99-.71v.96c-.56.41-1.31.61-2.23.61s-1.62-.29-2.13-.87c-.52-.58-.78-1.4-.78-2.46,0-1,.28-1.81.84-2.43.57-.63,1.27-.94,2.11-.94s1.49.27,1.94.81c.46.54.69,1.29.69,2.26v.54Zm-1.05-.87c0-.59-.15-1.05-.43-1.38-.28-.33-.67-.49-1.17-.49s-.89.17-1.23.52c-.34.35-.55.8-.63,1.36h3.46Zm5.65-4.77c-.2-.11-.43-.17-.68-.17-.72,0-1.08.45-1.08,1.36v.99h1.5v.88h-1.5v5.53h-1.02v-5.53h-1.09v-.88h1.09v-1.04c0-.67.19-1.2.58-1.59.39-.39.87-.59,1.45-.59.31,0,.56.04.74.11v.93Z" />
				<path d="m907.95,537.8c-.19,0-.36-.07-.49-.21-.13-.14-.2-.3-.2-.49s.07-.36.2-.49c.14-.14.3-.21.49-.21s.36.07.5.21c.14.14.21.3.21.49s-.07.36-.21.49c-.14.14-.3.21-.5.21Z" />
				<path d="m145.32,623.86v-13.92h3.96c1.2,0,2.16.29,2.86.88.71.59,1.06,1.36,1.06,2.3,0,.79-.21,1.48-.64,2.06s-1.02,1-1.77,1.24v.04c.94.11,1.69.47,2.25,1.07.56.6.84,1.37.84,2.33,0,1.19-.43,2.16-1.28,2.89-.85.74-1.93,1.11-3.23,1.11h-4.06Zm1.63-12.45v4.5h1.67c.89,0,1.6-.21,2.11-.64.51-.43.77-1.04.77-1.83,0-1.35-.89-2.03-2.67-2.03h-1.87Zm0,5.96v5.01h2.21c.96,0,1.7-.23,2.22-.68.53-.45.8-1.07.8-1.86,0-1.64-1.12-2.47-3.36-2.47h-1.87Zm16.66,6.49h-1.59v-1.55h-.04c-.69,1.19-1.71,1.79-3.06,1.79-.99,0-1.77-.26-2.33-.79-.56-.52-.83-1.22-.83-2.09,0-1.86,1.09-2.94,3.28-3.24l2.98-.42c0-1.69-.68-2.53-2.05-2.53-1.2,0-2.28.41-3.24,1.22v-1.63c.98-.62,2.1-.93,3.38-.93,2.34,0,3.51,1.24,3.51,3.71v6.47Zm-1.59-5.03l-2.4.33c-.74.1-1.29.29-1.67.55-.38.26-.56.72-.56,1.39,0,.49.17.88.51,1.19.35.3.81.46,1.39.46.79,0,1.44-.28,1.95-.83.52-.56.78-1.26.78-2.11v-.99Zm9.2,4.93c-.38.21-.87.31-1.49.31-1.74,0-2.61-.97-2.61-2.91v-5.88h-1.71v-1.36h1.71v-2.43l1.59-.51v2.94h2.5v1.36h-2.5v5.6c0,.67.11,1.14.34,1.43.23.28.6.43,1.13.43.4,0,.75-.11,1.04-.33v1.36Zm10.38.1h-1.59v-5.73c0-2.07-.77-3.11-2.31-3.11-.78,0-1.43.3-1.96.9-.53.6-.8,1.36-.8,2.3v5.63h-1.59v-14.72h1.59v6.43h.04c.76-1.26,1.85-1.88,3.26-1.88,2.24,0,3.36,1.35,3.36,4.05v6.13Z" />
				<path d="m383.42,664.54h-7.38v-13.92h7.07v1.48h-5.44v4.63h5.03v1.47h-5.03v4.87h5.75v1.48Zm10.73,0h-1.59v-5.67c0-2.11-.77-3.17-2.31-3.17-.8,0-1.46.3-1.98.9-.52.6-.78,1.35-.78,2.26v5.67h-1.59v-9.94h1.59v1.65h.04c.75-1.26,1.84-1.88,3.26-1.88,1.09,0,1.92.35,2.5,1.06.58.7.86,1.71.86,3.04v6.08Zm7.62-.1c-.38.21-.87.31-1.49.31-1.74,0-2.61-.97-2.61-2.91v-5.88h-1.71v-1.36h1.71v-2.43l1.59-.51v2.94h2.5v1.36h-2.5v5.6c0,.67.11,1.14.34,1.43.23.28.6.43,1.13.43.4,0,.75-.11,1.04-.33v1.36Zm7.33-8.23c-.28-.21-.68-.32-1.2-.32-.68,0-1.25.32-1.71.96-.45.64-.68,1.51-.68,2.62v5.07h-1.59v-9.94h1.59v2.05h.04c.23-.7.57-1.24,1.04-1.63.47-.39.99-.59,1.56-.59.41,0,.73.05.95.14v1.65Zm9.66-1.61l-4.57,11.53c-.82,2.06-1.96,3.09-3.44,3.09-.41,0-.76-.04-1.04-.13v-1.43c.34.12.66.17.94.17.8,0,1.4-.48,1.81-1.44l.8-1.88-3.88-9.92h1.77l2.69,7.65c.03.1.1.35.2.76h.06c.03-.16.1-.4.19-.74l2.83-7.67h1.65Z" />
				<path d="m787.13,597.2h-2.27l-5.38-6.37c-.2-.24-.32-.4-.37-.49h-.04v6.85h-1.63v-13.92h1.63v6.54h.04c.09-.14.21-.3.37-.48l5.2-6.07h2.03l-5.97,6.68,6.39,7.24Zm2.43-12.47c-.28,0-.53-.1-.73-.29-.2-.19-.3-.44-.3-.74s.1-.54.3-.74c.2-.2.44-.3.73-.3s.54.1.74.3c.21.19.31.44.31.74s-.1.53-.31.73c-.2.2-.45.3-.74.3Zm.78,12.47h-1.59v-9.94h1.59v9.94Zm7.82-.1c-.38.21-.87.31-1.49.31-1.74,0-2.61-.97-2.61-2.91v-5.88h-1.71v-1.36h1.71v-2.43l1.59-.51v2.94h2.5v1.36h-2.5v5.6c0,.67.11,1.14.34,1.43.23.28.6.43,1.13.43.4,0,.75-.11,1.04-.33v1.36Zm8.89-.36c-.76.46-1.67.69-2.72.69-1.42,0-2.56-.46-3.44-1.38-.87-.93-1.3-2.12-1.3-3.59,0-1.64.47-2.95,1.41-3.94.94-1,2.19-1.5,3.76-1.5.87,0,1.64.16,2.31.49v1.63c-.74-.52-1.53-.78-2.37-.78-1.02,0-1.85.37-2.5,1.1-.65.72-.97,1.68-.97,2.86s.3,2.08.91,2.76c.61.67,1.44,1.01,2.47,1.01.87,0,1.68-.29,2.45-.86v1.51Zm10.65.46h-1.59v-5.73c0-2.07-.77-3.11-2.31-3.11-.78,0-1.43.3-1.96.9-.53.6-.8,1.36-.8,2.3v5.63h-1.59v-14.72h1.59v6.43h.04c.76-1.26,1.85-1.88,3.26-1.88,2.24,0,3.36,1.35,3.36,4.05v6.13Zm10.98-4.57h-7.02c.03,1.11.32,1.96.89,2.56s1.35.9,2.35.9c1.12,0,2.15-.37,3.09-1.11v1.5c-.87.63-2.03.95-3.47.95s-2.51-.45-3.31-1.35c-.8-.91-1.2-2.18-1.2-3.82,0-1.55.44-2.81,1.31-3.78.88-.98,1.97-1.47,3.27-1.47s2.31.42,3.02,1.26c.71.84,1.07,2.01,1.07,3.51v.83Zm-1.63-1.35c0-.92-.23-1.63-.67-2.15-.43-.51-1.04-.77-1.82-.77s-1.39.27-1.91.81c-.52.54-.85,1.24-.97,2.11h5.37Zm12.28,5.92h-1.59v-5.67c0-2.11-.77-3.17-2.31-3.17-.8,0-1.46.3-1.98.9-.52.6-.78,1.35-.78,2.26v5.67h-1.59v-9.94h1.59v1.65h.04c.75-1.26,1.84-1.88,3.26-1.88,1.09,0,1.92.35,2.5,1.06.58.7.86,1.71.86,3.04v6.08Z" />
				<path d="m711.47,386.67h-7.22v-13.92h1.63v12.45h5.59v1.48Zm2.73-12.47c-.28,0-.53-.1-.73-.29s-.3-.44-.3-.74.1-.54.3-.74c.2-.2.44-.3.73-.3s.54.1.74.3c.21.19.31.44.31.74s-.1.53-.31.73c-.2.2-.45.3-.74.3Zm.78,12.47h-1.59v-9.94h1.59v9.94Zm11.03-9.94l-3.96,9.94h-1.56l-3.77-9.94h1.75l2.52,7.22c.19.53.3.99.35,1.39h.04c.06-.5.17-.95.31-1.35l2.64-7.26h1.68Zm2.51-2.52c-.28,0-.53-.1-.73-.29-.2-.19-.3-.44-.3-.74s.1-.54.3-.74c.2-.2.44-.3.73-.3s.54.1.74.3c.21.19.31.44.31.74s-.1.53-.31.73c-.2.2-.45.3-.74.3Zm.78,12.47h-1.59v-9.94h1.59v9.94Zm11.46,0h-1.59v-5.67c0-2.11-.77-3.17-2.31-3.17-.8,0-1.46.3-1.98.9-.52.6-.78,1.35-.78,2.26v5.67h-1.59v-9.94h1.59v1.65h.04c.75-1.26,1.84-1.88,3.26-1.88,1.09,0,1.92.35,2.5,1.06.58.7.86,1.71.86,3.04v6.08Zm11.48-.8c0,3.65-1.75,5.48-5.24,5.48-1.23,0-2.3-.23-3.22-.7v-1.59c1.12.62,2.19.93,3.2.93,2.45,0,3.67-1.3,3.67-3.9v-1.09h-.04c-.76,1.27-1.9,1.9-3.42,1.9-1.24,0-2.23-.44-2.99-1.32-.75-.89-1.13-2.07-1.13-3.56,0-1.69.4-3.03,1.21-4.03.82-1,1.93-1.5,3.34-1.5s2.33.54,2.98,1.61h.04v-1.38h1.59v9.15Zm-1.59-3.7v-1.47c0-.79-.27-1.47-.81-2.03-.53-.56-1.19-.84-1.99-.84-.98,0-1.75.36-2.31,1.08-.56.71-.84,1.71-.84,3,0,1.11.27,1.99.8,2.66.54.66,1.25.99,2.13.99s1.62-.32,2.17-.95c.56-.63.84-1.45.84-2.44Z" />
				<polygon points="761.73 372.75 755.05 388.98 753.57 388.98 760.23 372.75 761.73 372.75" />
				<path d="m763.35,386.67v-13.92h3.84c4.91,0,7.36,2.26,7.36,6.79,0,2.15-.68,3.88-2.05,5.18-1.36,1.3-3.18,1.95-5.47,1.95h-3.69Zm1.63-12.45v10.97h2.08c1.83,0,3.25-.49,4.26-1.47,1.02-.98,1.52-2.36,1.52-4.16,0-3.57-1.9-5.35-5.69-5.35h-2.17Zm12.84-.02c-.28,0-.53-.1-.73-.29-.2-.19-.3-.44-.3-.74s.1-.54.3-.74c.2-.2.44-.3.73-.3s.54.1.74.3c.21.19.31.44.31.74s-.1.53-.31.73c-.2.2-.45.3-.74.3Zm.78,12.47h-1.59v-9.94h1.59v9.94Zm11.41,0h-1.59v-5.67c0-2.11-.77-3.17-2.31-3.17-.8,0-1.46.3-1.98.9-.52.6-.78,1.35-.78,2.26v5.67h-1.59v-9.94h1.59v1.65h.04c.75-1.26,1.84-1.88,3.26-1.88,1.09,0,1.92.35,2.5,1.06.58.7.86,1.71.86,3.04v6.08Zm3.75-12.47c-.28,0-.53-.1-.73-.29-.2-.19-.3-.44-.3-.74s.1-.54.3-.74c.2-.2.44-.3.73-.3s.54.1.74.3c.21.19.31.44.31.74s-.1.53-.31.73c-.2.2-.45.3-.74.3Zm.78,12.47h-1.59v-9.94h1.59v9.94Zm11.41,0h-1.59v-5.67c0-2.11-.77-3.17-2.31-3.17-.8,0-1.46.3-1.98.9-.52.6-.78,1.35-.78,2.26v5.67h-1.59v-9.94h1.59v1.65h.04c.75-1.26,1.84-1.88,3.26-1.88,1.09,0,1.92.35,2.5,1.06.58.7.86,1.71.86,3.04v6.08Zm11.42-.8c0,3.65-1.75,5.48-5.24,5.48-1.23,0-2.3-.23-3.22-.7v-1.59c1.12.62,2.19.93,3.2.93,2.45,0,3.67-1.3,3.67-3.9v-1.09h-.04c-.76,1.27-1.9,1.9-3.42,1.9-1.24,0-2.23-.44-2.99-1.32-.75-.89-1.13-2.07-1.13-3.56,0-1.69.4-3.03,1.21-4.03.82-1,1.93-1.5,3.34-1.5s2.33.54,2.98,1.61h.04v-1.38h1.59v9.15Zm-1.59-3.7v-1.47c0-.79-.27-1.47-.81-2.03-.53-.56-1.19-.84-1.99-.84-.98,0-1.75.36-2.31,1.08-.56.71-.84,1.71-.84,3,0,1.11.27,1.99.8,2.66.54.66,1.25.99,2.13.99s1.62-.32,2.17-.95c.56-.63.84-1.45.84-2.44Z" />
				<path d="m836.41,386.67h-1.94l-2.33-3.9c-.21-.36-.42-.67-.62-.92-.2-.26-.41-.47-.62-.63-.21-.16-.43-.28-.68-.35-.24-.08-.51-.12-.82-.12h-1.34v5.92h-1.63v-13.92h4.16c.61,0,1.17.08,1.68.23.52.15.96.38,1.34.69.38.31.68.7.89,1.17.21.46.32,1,.32,1.62,0,.49-.07.93-.22,1.34-.14.4-.35.76-.62,1.08-.27.32-.59.59-.97.82-.38.22-.8.39-1.27.51v.04c.23.1.43.22.6.36.17.13.34.28.5.47.16.18.31.39.46.62.16.23.33.49.51.8l2.61,4.18Zm-8.35-12.45v5.05h2.21c.41,0,.78-.06,1.13-.18.35-.12.65-.3.9-.52.25-.23.45-.51.59-.84.14-.34.21-.71.21-1.13,0-.74-.24-1.32-.73-1.74-.48-.42-1.17-.63-2.09-.63h-2.23Zm14.14,12.68c-1.47,0-2.64-.46-3.52-1.39-.87-.93-1.31-2.17-1.31-3.7,0-1.67.46-2.97,1.37-3.91.91-.94,2.15-1.41,3.7-1.41s2.64.46,3.47,1.37c.83.91,1.25,2.18,1.25,3.8s-.45,2.86-1.35,3.82c-.89.95-2.09,1.43-3.6,1.43Zm.12-9.07c-1.02,0-1.83.35-2.43,1.05-.6.69-.89,1.65-.89,2.87s.3,2.11.9,2.79c.6.68,1.41,1.02,2.42,1.02s1.82-.33,2.37-1c.56-.67.84-1.61.84-2.84s-.28-2.2-.84-2.87c-.55-.67-1.34-1.01-2.37-1.01h0Zm11.47,9.07c-1.47,0-2.64-.46-3.52-1.39-.87-.93-1.31-2.17-1.31-3.7,0-1.67.46-2.97,1.37-3.91.91-.94,2.15-1.41,3.7-1.41s2.64.46,3.47,1.37c.83.91,1.25,2.18,1.25,3.8s-.45,2.86-1.35,3.82c-.89.95-2.09,1.43-3.6,1.43Zm.12-9.07c-1.02,0-1.83.35-2.43,1.05-.6.69-.89,1.65-.89,2.87s.3,2.11.9,2.79c.6.68,1.41,1.02,2.42,1.02s1.82-.33,2.37-1c.56-.67.83-1.61.83-2.84s-.28-2.2-.83-2.87c-.55-.67-1.34-1.01-2.37-1.01h0Zm21.43,8.84h-1.59v-5.71c0-1.1-.17-1.9-.51-2.39-.34-.49-.91-.74-1.71-.74-.68,0-1.26.31-1.74.93-.47.62-.71,1.37-.71,2.23v5.67h-1.59v-5.9c0-1.95-.75-2.93-2.26-2.93-.7,0-1.28.29-1.73.88-.45.58-.68,1.34-.68,2.28v5.67h-1.59v-9.94h1.59v1.57h.04c.71-1.2,1.73-1.81,3.09-1.81.68,0,1.27.19,1.78.57.5.38.85.87,1.04,1.49.74-1.37,1.84-2.06,3.3-2.06,2.19,0,3.28,1.35,3.28,4.05v6.13Z" />
				<path d="m754.87,407.3h-1.16v-8.75c-.09.09-.22.19-.4.31-.17.11-.36.23-.58.34-.21.11-.44.22-.68.32-.24.1-.47.18-.69.23v-1.17c.25-.07.52-.16.81-.28.29-.12.57-.26.84-.4.28-.15.54-.31.78-.47.24-.16.46-.32.64-.48h.44v10.35Zm8.15-7.47c0-.31-.05-.58-.15-.81-.09-.23-.23-.42-.4-.57-.16-.16-.36-.27-.59-.35-.23-.08-.47-.11-.73-.11-.23,0-.45.03-.66.09-.22.06-.43.15-.64.25-.2.11-.4.24-.59.39-.19.15-.36.32-.53.5v-1.24c.32-.32.69-.56,1.09-.72.4-.17.9-.25,1.48-.25.41,0,.8.06,1.15.18.35.12.66.29.92.52.26.23.46.52.61.85.15.34.23.73.23,1.17,0,.4-.05.76-.14,1.09-.09.32-.23.63-.42.92-.18.29-.42.56-.7.83-.28.26-.61.53-1,.81-.48.34-.87.63-1.18.87-.31.24-.55.47-.73.68-.18.21-.31.42-.38.63-.07.21-.11.45-.11.72h5.04v1.04h-6.25v-.5c0-.43.05-.81.14-1.14.09-.33.25-.64.47-.94s.5-.59.85-.89c.35-.3.78-.63,1.29-1,.37-.26.67-.52.92-.76.25-.24.45-.48.6-.72.15-.24.26-.48.32-.73.07-.25.1-.51.1-.79Z" />
				<rect x="766.53" y="397.17" width="1.02" height="3.16" />
				<path d="m775.87,404.09c0,.49-.08.95-.24,1.36-.16.41-.38.77-.66,1.07-.28.3-.62.54-1.01.71-.39.16-.81.25-1.27.25-.51,0-.97-.11-1.37-.32-.4-.21-.74-.52-1.02-.91-.28-.4-.49-.89-.64-1.46-.15-.57-.22-1.22-.22-1.94,0-.88.1-1.68.29-2.39.2-.72.48-1.33.83-1.84.36-.51.8-.91,1.31-1.19.51-.28,1.08-.42,1.7-.42.7,0,1.26.1,1.68.29v1.09c-.52-.27-1.07-.4-1.65-.4-.45,0-.86.1-1.22.3-.36.2-.67.49-.93.86-.26.37-.46.81-.6,1.33-.14.52-.2,1.1-.2,1.74h.03c.47-.84,1.24-1.26,2.31-1.26.44,0,.84.08,1.19.23.36.15.66.36.91.64.25.27.45.6.59.98s.2.81.2,1.27Zm-1.19.15c0-.35-.04-.67-.13-.95-.09-.28-.22-.52-.39-.72-.16-.2-.37-.35-.61-.45-.24-.11-.52-.16-.83-.16-.29,0-.55.05-.8.16-.24.11-.46.26-.64.44-.18.18-.32.4-.42.65-.1.24-.15.51-.15.78,0,.35.05.68.15.98.1.3.24.56.42.79.18.23.39.4.64.54.25.13.52.19.83.19s.56-.05.8-.16c.24-.11.44-.27.61-.47.17-.2.3-.43.4-.71.09-.28.14-.58.14-.92Z" />
				<path d="m778.63,397.17v3.16h-1.02v-3.16h1.02Zm2.34,0v3.16h-1.02v-3.16h1.02Z" />
				<path d="m792.55,400.07l-2.43,3.66,2.39,3.57h-1.35l-1.42-2.34c-.09-.15-.2-.33-.32-.55h-.03s-.13.23-.33.55l-1.45,2.34h-1.33l2.46-3.55-2.36-3.69h1.35l1.4,2.47c.1.18.2.37.3.56h.03l1.81-3.04h1.28Z" />
				<path d="m801.81,407.3h-1.16v-8.75c-.09.09-.22.19-.4.31-.17.11-.36.23-.58.34-.21.11-.44.22-.68.32-.24.1-.47.18-.69.23v-1.17c.25-.07.52-.16.81-.28.29-.12.57-.26.84-.4.28-.15.54-.31.78-.47.24-.16.46-.32.64-.48h.44v10.35Zm8.15-7.47c0-.31-.05-.58-.15-.81-.09-.23-.23-.42-.4-.57-.16-.16-.36-.27-.59-.35-.23-.08-.47-.11-.73-.11-.23,0-.45.03-.66.09-.22.06-.43.15-.64.25-.2.11-.4.24-.59.39-.19.15-.36.32-.53.5v-1.24c.32-.32.69-.56,1.09-.72.4-.17.9-.25,1.48-.25.41,0,.8.06,1.15.18.35.12.66.29.92.52.26.23.46.52.61.85.15.34.23.73.23,1.17,0,.4-.05.76-.14,1.09-.09.32-.23.63-.42.92-.18.29-.42.56-.7.83-.28.26-.61.53-1,.81-.48.34-.87.63-1.18.87-.31.24-.55.47-.73.68-.18.21-.31.42-.38.63-.07.21-.11.45-.11.72h5.04v1.04h-6.25v-.5c0-.43.05-.81.14-1.14.09-.33.25-.64.47-.94.22-.3.5-.59.85-.89.35-.3.78-.63,1.29-1,.37-.26.67-.52.92-.76.25-.24.45-.48.6-.72.15-.24.26-.48.32-.73.07-.25.1-.51.1-.79Z" />
				<rect x="813.46" y="397.17" width="1.02" height="3.16" />
				<path d="m816.22,404.48c0-.27.04-.54.13-.81.08-.27.2-.53.36-.76.16-.24.36-.45.59-.64.24-.19.5-.35.8-.46-.44-.24-.79-.56-1.05-.94-.26-.39-.39-.81-.39-1.28,0-.37.07-.72.21-1.03.15-.32.35-.59.6-.82.25-.23.56-.41.9-.54.35-.13.73-.2,1.13-.2s.79.07,1.14.2c.35.13.65.31.9.54.25.23.45.5.59.82.14.32.21.66.21,1.02,0,.47-.13.89-.39,1.28-.26.38-.6.69-1.03.94.29.11.55.27.78.46s.42.41.58.64c.16.24.28.49.37.76.08.27.13.54.13.81,0,.44-.08.85-.24,1.21-.16.37-.39.68-.68.95-.29.26-.63.46-1.04.61-.4.15-.84.22-1.33.22s-.92-.07-1.32-.22-.75-.35-1.04-.61c-.29-.26-.52-.58-.68-.95-.16-.37-.24-.77-.24-1.21Zm1.26-.1c0,.32.05.6.14.85.1.25.24.47.41.65.18.18.39.32.64.42.25.09.53.14.84.14s.57-.05.82-.15c.25-.1.46-.24.64-.42.18-.18.32-.4.42-.65.1-.25.16-.54.16-.85,0-.28-.05-.55-.15-.79-.09-.25-.23-.47-.41-.66-.18-.19-.39-.34-.64-.44-.25-.11-.53-.16-.84-.16-.29,0-.56.05-.81.16-.24.1-.46.24-.64.42-.18.18-.32.4-.42.65-.1.25-.16.52-.16.83Zm.36-4.7c0,.24.04.46.13.67.09.2.21.38.36.54.16.15.33.27.54.36.2.08.42.13.65.13s.45-.04.65-.13c.21-.09.39-.21.54-.36.15-.16.27-.33.36-.54.09-.21.13-.43.13-.66s-.04-.47-.13-.68c-.08-.21-.2-.39-.35-.54s-.33-.27-.54-.35c-.2-.09-.42-.13-.66-.13-.25,0-.48.04-.69.13-.2.09-.38.21-.53.37-.15.15-.26.33-.34.54-.08.21-.12.43-.12.66Z" />
				<path d="m825.57,397.17v3.16h-1.02v-3.16h1.02Zm2.34,0v3.16h-1.02v-3.16h1.02Z" />
				<path d="m168.79,390.53v-13.92h3.96c1.2,0,2.16.29,2.86.88s1.06,1.36,1.06,2.3c0,.79-.21,1.48-.64,2.06-.43.58-1.02,1-1.77,1.24v.04c.94.11,1.69.47,2.25,1.07.56.6.84,1.37.84,2.33,0,1.19-.43,2.16-1.28,2.89-.85.74-1.93,1.11-3.23,1.11h-4.06Zm1.63-12.45v4.5h1.67c.89,0,1.6-.21,2.11-.64.51-.43.77-1.04.77-1.83,0-1.35-.89-2.03-2.67-2.03h-1.87Zm0,5.96v5.01h2.21c.96,0,1.7-.23,2.22-.68.53-.45.8-1.07.8-1.86,0-1.64-1.12-2.47-3.36-2.47h-1.87Zm17.52,1.91h-7.02c.03,1.11.32,1.96.89,2.56s1.35.9,2.35.9c1.12,0,2.15-.37,3.09-1.11v1.5c-.87.63-2.03.95-3.47.95s-2.51-.45-3.31-1.35c-.8-.91-1.2-2.18-1.2-3.82,0-1.55.44-2.81,1.31-3.78.88-.98,1.97-1.47,3.27-1.47s2.31.42,3.02,1.26c.71.84,1.07,2.01,1.07,3.5v.83Zm-1.63-1.35c0-.92-.23-1.63-.67-2.15-.43-.51-1.04-.77-1.82-.77s-1.39.27-1.91.81c-.52.54-.85,1.24-.97,2.11h5.37Zm12.51,5.92h-1.59v-1.69h-.04c-.74,1.28-1.88,1.92-3.42,1.92-1.25,0-2.25-.44-3-1.33-.74-.89-1.12-2.11-1.12-3.64,0-1.64.41-2.96,1.24-3.95.83-.99,1.93-1.49,3.31-1.49s2.36.54,2.98,1.61h.04v-6.16h1.59v14.72Zm-1.59-4.5v-1.47c0-.8-.27-1.48-.8-2.04-.53-.56-1.2-.83-2.02-.83-.97,0-1.73.36-2.29,1.07-.56.71-.83,1.7-.83,2.95,0,1.15.27,2.05.8,2.72.54.66,1.26.99,2.16.99s1.61-.32,2.16-.96c.56-.64.83-1.45.83-2.43Zm9.98-3.84c-.28-.21-.68-.32-1.2-.32-.68,0-1.25.32-1.71.96-.45.64-.68,1.51-.68,2.62v5.07h-1.59v-9.94h1.59v2.05h.04c.23-.7.57-1.24,1.04-1.63.47-.39.99-.59,1.56-.59.41,0,.73.05.95.14v1.65Zm5.87,8.56c-1.47,0-2.64-.46-3.52-1.39-.87-.93-1.31-2.17-1.31-3.7,0-1.67.46-2.97,1.37-3.91.91-.94,2.15-1.41,3.7-1.41s2.64.46,3.47,1.37c.83.91,1.25,2.18,1.25,3.8s-.45,2.86-1.35,3.82c-.89.95-2.09,1.43-3.6,1.43Zm.12-9.07c-1.02,0-1.83.35-2.43,1.05-.6.69-.89,1.65-.89,2.87s.3,2.11.9,2.79,1.41,1.02,2.42,1.02,1.82-.33,2.37-1c.56-.67.83-1.61.83-2.84s-.28-2.2-.83-2.87c-.55-.67-1.34-1.01-2.37-1.01Zm11.51,9.07c-1.47,0-2.64-.46-3.52-1.39-.87-.93-1.31-2.17-1.31-3.7,0-1.67.46-2.97,1.37-3.91.91-.94,2.15-1.41,3.7-1.41s2.64.46,3.47,1.37c.83.91,1.25,2.18,1.25,3.8s-.45,2.86-1.35,3.82c-.89.95-2.09,1.43-3.6,1.43Zm.12-9.07c-1.02,0-1.83.35-2.43,1.05-.6.69-.89,1.65-.89,2.87s.3,2.11.9,2.79c.6.68,1.41,1.02,2.42,1.02s1.82-.33,2.37-1c.56-.67.83-1.61.83-2.84s-.28-2.2-.83-2.87c-.55-.67-1.34-1.01-2.37-1.01Zm21.48,8.84h-1.59v-5.71c0-1.1-.17-1.9-.51-2.39-.34-.49-.91-.74-1.71-.74-.68,0-1.26.31-1.74.93-.47.62-.71,1.37-.71,2.23v5.67h-1.59v-5.9c0-1.95-.75-2.93-2.26-2.93-.7,0-1.28.29-1.73.88-.45.58-.68,1.34-.68,2.28v5.67h-1.59v-9.94h1.59v1.57h.04c.71-1.2,1.73-1.81,3.09-1.81.68,0,1.27.19,1.78.57.5.38.85.87,1.04,1.49.74-1.37,1.84-2.06,3.3-2.06,2.19,0,3.28,1.35,3.28,4.05v6.13Z" />
				<path d="m260.13,390.53h-1.59v-12.03c-.12.12-.3.27-.54.43-.23.16-.5.31-.8.47-.29.16-.6.3-.93.44-.32.14-.64.24-.95.32v-1.61c.35-.1.72-.23,1.11-.39.39-.17.78-.35,1.16-.55.38-.21.74-.42,1.08-.64.34-.23.63-.45.87-.66h.6v14.23Z" />
				<path d="m176.95,411.16h-1.16v-8.75c-.09.09-.22.19-.4.31-.17.11-.36.23-.58.34-.21.11-.44.22-.68.32-.24.1-.47.18-.69.23v-1.17c.25-.07.52-.16.81-.28.29-.12.57-.26.84-.4.28-.15.54-.31.78-.47.24-.16.46-.32.64-.48h.44v10.35Zm8.15-7.47c0-.31-.05-.58-.15-.81-.09-.23-.23-.42-.4-.57-.16-.16-.36-.27-.59-.35-.23-.08-.47-.11-.73-.11-.23,0-.45.03-.66.09-.22.06-.43.15-.64.25-.2.11-.4.24-.59.39-.19.15-.36.32-.53.5v-1.24c.32-.32.69-.56,1.09-.72.4-.17.9-.25,1.48-.25.41,0,.8.06,1.15.18.35.12.66.29.92.52.26.23.46.52.61.85.15.34.23.73.23,1.17,0,.4-.05.76-.14,1.09-.09.32-.23.63-.42.92-.18.29-.42.56-.7.83-.28.26-.61.53-1,.81-.48.34-.87.63-1.18.87-.31.24-.55.47-.73.68-.18.21-.31.42-.38.63-.07.21-.11.45-.11.72h5.04v1.04h-6.25v-.5c0-.43.05-.81.14-1.14.09-.33.25-.64.47-.94.22-.3.5-.59.85-.89.35-.3.78-.63,1.29-1,.37-.26.67-.52.92-.76.25-.24.45-.48.6-.72.15-.24.26-.48.32-.73.07-.25.1-.51.1-.79Z" />
				<rect x="188.6" y="401.03" width="1.02" height="3.16" />
				<path d="m195.84,411.16h-1.16v-8.75c-.09.09-.22.19-.4.31-.17.11-.36.23-.58.34-.21.11-.44.22-.68.32-.24.1-.47.18-.69.23v-1.17c.25-.07.52-.16.81-.28.29-.12.57-.26.84-.4.28-.15.54-.31.78-.47.24-.16.46-.32.64-.48h.44v10.35Zm7.81,0h-1.16v-8.75c-.09.09-.22.19-.4.31-.17.11-.36.23-.58.34-.21.11-.44.22-.68.32-.24.1-.47.18-.69.23v-1.17c.25-.07.52-.16.81-.28.29-.12.57-.26.84-.4.28-.15.54-.31.78-.47.24-.16.46-.32.64-.48h.44v10.35Z" />
				<path d="m208.51,401.03v3.16h-1.02v-3.16h1.02Zm2.34,0v3.16h-1.02v-3.16h1.02Z" />
				<path d="m222.43,403.93l-2.43,3.66,2.39,3.57h-1.35l-1.42-2.34c-.09-.15-.2-.33-.32-.55h-.03s-.13.23-.33.55l-1.45,2.34h-1.33l2.46-3.55-2.36-3.69h1.35l1.4,2.47c.1.18.2.37.3.56h.03l1.81-3.04h1.28Z" />
				<path d="m231.69,411.16h-1.16v-8.75c-.09.09-.22.19-.4.31-.17.11-.36.23-.58.34-.21.11-.44.22-.68.32-.24.1-.47.18-.69.23v-1.17c.25-.07.52-.16.81-.28.29-.12.57-.26.84-.4.28-.15.54-.31.78-.47.24-.16.46-.32.64-.48h.44v10.35Zm9.9-5.11c0,.85-.08,1.6-.23,2.25-.15.65-.37,1.21-.66,1.66-.29.45-.64.79-1.07,1.02-.42.23-.9.35-1.43.35-.51,0-.96-.11-1.36-.33-.4-.23-.73-.55-1-.98-.27-.43-.48-.95-.62-1.57-.14-.63-.21-1.34-.21-2.15,0-.89.07-1.67.22-2.34.15-.68.37-1.25.66-1.7.29-.46.64-.81,1.07-1.04.43-.24.92-.35,1.47-.35,2.12,0,3.18,1.73,3.18,5.19Zm-1.19.11c0-2.88-.69-4.32-2.06-4.32-1.45,0-2.17,1.47-2.17,4.4,0,2.74.71,4.1,2.13,4.1s2.1-1.39,2.1-4.18Z" />
				<rect x="243.34" y="401.03" width="1.02" height="3.16" />
				<path d="m252.2,408.29c0,.46-.09.87-.26,1.25-.17.37-.41.69-.73.96-.31.26-.69.47-1.12.61-.44.15-.92.22-1.45.22-.97,0-1.73-.18-2.3-.55v-1.24c.68.54,1.46.81,2.34.81.35,0,.67-.04.95-.13.29-.09.53-.22.73-.39.21-.17.36-.37.47-.61.11-.24.17-.51.17-.81,0-1.32-.94-1.98-2.82-1.98h-.84v-.98h.8c1.67,0,2.5-.62,2.5-1.86,0-1.15-.64-1.72-1.91-1.72-.72,0-1.39.24-2.01.72v-1.12c.65-.39,1.41-.58,2.3-.58.42,0,.81.06,1.15.18.34.12.64.28.88.49.24.21.43.47.56.76.14.3.2.62.2.98,0,1.33-.67,2.19-2.02,2.57v.03c.34.04.66.12.95.25.29.13.54.29.76.5.21.21.38.45.49.73.12.28.18.59.18.93Z" />
				<path d="m255.45,401.03v3.16h-1.02v-3.16h1.02Zm2.34,0v3.16h-1.02v-3.16h1.02Z" />
				<path d="m433.37,418.51v-13.92h3.96c1.2,0,2.16.29,2.86.88.71.59,1.06,1.36,1.06,2.3,0,.79-.21,1.48-.64,2.06-.43.58-1.02,1-1.77,1.24v.04c.94.11,1.69.47,2.25,1.07.56.6.84,1.37.84,2.33,0,1.19-.43,2.16-1.28,2.89-.85.74-1.93,1.11-3.23,1.11h-4.06Zm1.63-12.45v4.5h1.67c.89,0,1.6-.21,2.11-.64.51-.43.77-1.04.77-1.83,0-1.35-.89-2.03-2.67-2.03h-1.87Zm0,5.96v5.01h2.21c.96,0,1.7-.23,2.22-.68.53-.45.8-1.07.8-1.86,0-1.64-1.12-2.47-3.36-2.47h-1.87Zm17.52,1.91h-7.02c.03,1.11.32,1.96.89,2.56.57.6,1.35.9,2.35.9,1.12,0,2.15-.37,3.09-1.11v1.5c-.87.63-2.03.95-3.47.95s-2.51-.45-3.31-1.35c-.8-.91-1.2-2.18-1.2-3.82,0-1.55.44-2.81,1.31-3.78.88-.98,1.97-1.47,3.27-1.47s2.31.42,3.02,1.26c.71.84,1.07,2.01,1.07,3.51v.83Zm-1.63-1.35c0-.92-.23-1.63-.67-2.15-.43-.51-1.04-.77-1.82-.77s-1.39.27-1.91.81c-.52.54-.85,1.24-.97,2.11h5.37Zm12.51,5.92h-1.59v-1.69h-.04c-.74,1.28-1.88,1.92-3.42,1.92-1.25,0-2.25-.44-3-1.33-.74-.89-1.12-2.11-1.12-3.64,0-1.64.41-2.96,1.24-3.95.83-.99,1.93-1.49,3.31-1.49s2.36.54,2.98,1.61h.04v-6.16h1.59v14.72Zm-1.59-4.5v-1.47c0-.8-.27-1.48-.8-2.04-.53-.56-1.2-.83-2.02-.83-.97,0-1.73.36-2.29,1.07-.56.71-.84,1.7-.84,2.95,0,1.15.27,2.05.8,2.72.54.66,1.26.99,2.16.99s1.61-.32,2.16-.96c.56-.64.84-1.45.84-2.43Zm9.98-3.84c-.28-.21-.68-.32-1.2-.32-.68,0-1.25.32-1.71.96-.45.64-.68,1.51-.68,2.62v5.07h-1.59v-9.94h1.59v2.05h.04c.23-.7.57-1.24,1.04-1.63.47-.39.99-.59,1.56-.59.41,0,.73.05.95.14v1.65Zm5.87,8.56c-1.47,0-2.64-.46-3.52-1.39-.87-.93-1.31-2.17-1.31-3.7,0-1.67.46-2.97,1.37-3.91.91-.94,2.15-1.41,3.7-1.41s2.64.46,3.47,1.37c.84.91,1.25,2.18,1.25,3.8s-.45,2.86-1.35,3.82c-.89.95-2.09,1.43-3.6,1.43Zm.12-9.07c-1.02,0-1.83.35-2.43,1.05-.6.69-.89,1.65-.89,2.87s.3,2.11.9,2.79c.6.68,1.41,1.02,2.42,1.02s1.82-.33,2.37-1c.56-.67.83-1.61.83-2.84s-.28-2.2-.83-2.87c-.55-.67-1.34-1.01-2.37-1.01Zm11.51,9.07c-1.47,0-2.64-.46-3.52-1.39-.87-.93-1.31-2.17-1.31-3.7,0-1.67.46-2.97,1.37-3.91.91-.94,2.15-1.41,3.7-1.41s2.64.46,3.47,1.37c.83.91,1.25,2.18,1.25,3.8s-.45,2.86-1.35,3.82c-.89.95-2.09,1.43-3.6,1.43Zm.12-9.07c-1.02,0-1.83.35-2.43,1.05-.6.69-.89,1.65-.89,2.87s.3,2.11.9,2.79c.6.68,1.41,1.02,2.42,1.02s1.82-.33,2.37-1c.56-.67.83-1.61.83-2.84s-.28-2.2-.83-2.87c-.55-.67-1.34-1.01-2.37-1.01Zm21.48,8.84h-1.59v-5.71c0-1.1-.17-1.9-.51-2.39-.34-.49-.91-.74-1.71-.74-.68,0-1.26.31-1.74.93-.47.62-.71,1.37-.71,2.23v5.67h-1.59v-5.9c0-1.95-.75-2.93-2.26-2.93-.7,0-1.28.29-1.73.88-.45.58-.68,1.34-.68,2.28v5.67h-1.59v-9.94h1.59v1.57h.04c.71-1.2,1.73-1.81,3.09-1.81.68,0,1.27.19,1.78.57.5.38.85.87,1.04,1.49.74-1.37,1.84-2.06,3.3-2.06,2.19,0,3.28,1.35,3.28,4.05v6.13Z" />
				<path d="m525.17,408.23c0-.43-.07-.8-.2-1.12-.13-.32-.31-.58-.54-.79-.23-.21-.5-.37-.81-.48s-.65-.16-1.01-.16c-.31,0-.61.04-.91.13-.3.08-.59.2-.87.35-.28.15-.55.33-.82.53-.26.21-.5.44-.73.69v-1.71c.45-.43.94-.76,1.5-.99.56-.23,1.23-.35,2.03-.35.57,0,1.1.08,1.58.25.49.16.91.4,1.26.72s.63.71.83,1.17c.21.47.31,1,.31,1.6,0,.55-.06,1.05-.19,1.5-.12.45-.31.87-.57,1.26-.25.39-.57.77-.96,1.14-.39.36-.84.73-1.37,1.11-.65.47-1.19.86-1.62,1.19-.42.33-.76.64-1.01.93-.25.28-.42.57-.52.86-.1.28-.15.61-.15.99h6.93v1.43h-8.59v-.69c0-.6.06-1.12.19-1.57.13-.45.34-.88.64-1.29.3-.41.69-.82,1.17-1.22.49-.41,1.08-.87,1.78-1.38.5-.36.93-.71,1.26-1.04.34-.33.62-.66.83-.99.21-.33.35-.66.44-1,.09-.34.14-.71.14-1.09Z" />
				<path d="m451.31,433.47c0,.93-.09,1.75-.28,2.48-.18.72-.45,1.33-.81,1.84-.35.5-.78.88-1.29,1.14-.51.26-1.09.39-1.74.39s-1.26-.12-1.77-.35v-1.11c.56.32,1.16.47,1.79.47.46,0,.86-.09,1.22-.28.36-.19.67-.46.92-.82.25-.36.44-.81.57-1.33.13-.53.2-1.13.2-1.81h-.03c-.43.87-1.19,1.31-2.26,1.31-.43,0-.83-.08-1.19-.23-.36-.16-.68-.37-.94-.65-.26-.28-.47-.62-.61-1-.15-.39-.22-.81-.22-1.28,0-.5.08-.96.24-1.37.16-.41.39-.77.68-1.07.29-.3.64-.53,1.03-.7.4-.16.84-.25,1.31-.25.51,0,.96.1,1.35.31.4.2.73.5,1,.9.27.39.47.87.61,1.45.14.57.21,1.23.21,1.97Zm-1.25-1.04c0-.39-.05-.75-.16-1.07-.1-.32-.24-.59-.42-.82-.18-.23-.39-.41-.64-.53-.24-.13-.51-.19-.81-.19s-.54.06-.78.17c-.24.11-.45.26-.63.47-.17.2-.31.44-.42.71-.1.27-.15.57-.15.9,0,.36.05.68.14.96.1.28.24.52.42.72.18.19.39.34.64.44.25.1.53.16.84.16.27,0,.52-.05.76-.15.24-.1.45-.24.62-.41.18-.17.32-.38.42-.61.1-.24.16-.49.16-.76Z" />
				<rect x="453.18" y="429.01" width="1.02" height="3.16" />
				<path d="m460.76,431.67c0-.31-.05-.58-.15-.81-.09-.23-.23-.42-.4-.57-.16-.16-.36-.27-.59-.35-.23-.08-.47-.11-.73-.11-.23,0-.45.03-.66.09-.22.06-.43.15-.64.25-.2.11-.4.24-.59.39-.19.15-.36.32-.53.5v-1.24c.32-.32.69-.56,1.09-.72.4-.17.9-.25,1.48-.25.41,0,.8.06,1.15.18.35.12.66.29.92.52.26.23.46.52.61.85.15.34.23.73.23,1.17,0,.4-.05.76-.14,1.09-.09.32-.23.63-.42.92-.18.29-.42.56-.7.83-.28.26-.61.53-1,.81-.48.34-.87.63-1.18.87-.31.24-.55.47-.73.68-.18.21-.31.42-.38.63-.07.21-.11.45-.11.72h5.04v1.04h-6.25v-.5c0-.43.05-.81.14-1.14.09-.33.25-.64.47-.94.22-.3.5-.59.85-.89.35-.3.78-.63,1.29-1,.37-.26.67-.52.92-.76.25-.24.45-.48.6-.72.15-.24.26-.48.32-.73.07-.25.1-.51.1-.79Z" />
				<path d="m465.28,429.01v3.16h-1.02v-3.16h1.02Zm2.34,0v3.16h-1.02v-3.16h1.02Z" />
				<path d="m479.2,431.91l-2.43,3.66,2.39,3.57h-1.35l-1.42-2.34c-.09-.15-.2-.33-.32-.55h-.03s-.13.23-.33.55l-1.45,2.34h-1.33l2.46-3.55-2.36-3.69h1.35l1.4,2.47c.1.18.2.37.3.56h.03l1.81-3.04h1.28Z" />
				<path d="m488.46,439.14h-1.16v-8.75c-.09.09-.22.19-.4.31-.17.11-.36.23-.58.34-.21.11-.44.22-.68.32-.24.1-.47.18-.69.23v-1.17c.25-.07.52-.16.81-.28.29-.12.57-.26.84-.4.28-.15.54-.31.78-.47.24-.16.46-.32.64-.48h.44v10.35Zm8.15-7.47c0-.31-.05-.58-.15-.81-.09-.23-.23-.42-.4-.57-.16-.16-.36-.27-.59-.35-.23-.08-.47-.11-.73-.11-.23,0-.45.03-.66.09-.22.06-.43.15-.64.25-.2.11-.4.24-.59.39-.19.15-.36.32-.53.5v-1.24c.32-.32.69-.56,1.09-.72.4-.17.9-.25,1.48-.25.41,0,.8.06,1.15.18.35.12.66.29.92.52.26.23.46.52.61.85.15.34.23.73.23,1.17,0,.4-.05.76-.14,1.09-.09.32-.23.63-.42.92-.18.29-.42.56-.7.83-.28.26-.61.53-1,.81-.48.34-.87.63-1.18.87-.31.24-.55.47-.73.68-.18.21-.31.42-.38.63-.07.21-.11.45-.11.72h5.04v1.04h-6.25v-.5c0-.43.05-.81.14-1.14.09-.33.25-.64.47-.94.22-.3.5-.59.85-.89.35-.3.78-.63,1.29-1,.37-.26.67-.52.92-.76.25-.24.45-.48.6-.72s.26-.48.32-.73c.07-.25.1-.51.1-.79Z" />
				<rect x="500.11" y="429.01" width="1.02" height="3.16" />
				<path d="m509.37,429.68c-.16.27-.34.6-.56,1-.22.4-.45.85-.69,1.35-.24.5-.49,1.04-.75,1.61-.25.57-.49,1.17-.71,1.78-.22.61-.42,1.23-.59,1.86-.16.63-.28,1.24-.36,1.85h-1.24c.08-.6.21-1.22.39-1.84.18-.63.38-1.25.6-1.85.23-.61.46-1.19.71-1.75.25-.56.49-1.08.73-1.55s.45-.89.64-1.24c.2-.36.36-.64.47-.85h-5.08v-1.05h6.44v.67Z" />
				<path d="m512.22,429.01v3.16h-1.02v-3.16h1.02Zm2.34,0v3.16h-1.02v-3.16h1.02Z" />
				<path d="m306.03,703.78l-2.5,8.85h-1.22l-1.82-6.47c-.08-.28-.13-.58-.14-.9h-.02c-.02.3-.08.6-.16.89l-1.83,6.48h-1.2l-2.59-8.85h1.14l1.88,6.79c.08.28.13.58.15.89h.03c.02-.22.08-.51.19-.89l1.96-6.79h.99l1.88,6.84c.07.23.12.51.15.83h.02c.02-.21.07-.5.17-.85l1.81-6.82h1.12Z" />
				<polygon points="311.2 703.78 306.95 714.1 306.01 714.1 310.24 703.78 311.2 703.78" />
				<path d="m312.23,712.64v-8.85h2.45c3.12,0,4.68,1.44,4.68,4.32,0,1.37-.43,2.47-1.3,3.3-.86.83-2.02,1.24-3.48,1.24h-2.35Zm1.04-7.92v6.98h1.32c1.16,0,2.06-.31,2.71-.93.65-.62.97-1.5.97-2.64,0-2.27-1.21-3.4-3.62-3.4h-1.38Z" />
			</g>
		</g>
	)
}

export default PlanX
